import React from "react";
export const SvgIcons = {
  primaryRightarrowSvg: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.16663 9.99984H15.8333M15.8333 9.99984L9.99996 4.1665M15.8333 9.99984L9.99996 15.8332"
        stroke="#7F56D9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  deleteSvg: (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  deleteCurrentSvg: (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  deleteDangerSvg: (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  reloadSvg: (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.0441 10.7444C16.8126 12.9193 15.5803 14.9574 13.5411 16.1347C10.1532 18.0907 5.82114 16.9299 3.86513 13.542L3.6568 13.1812M2.95509 9.25602C3.18659 7.08111 4.41891 5.043 6.45807 3.8657C9.84598 1.90969 14.1781 3.07047 16.1341 6.45838L16.3424 6.81922M2.91095 15.0552L3.52099 12.7785L5.7977 13.3886M14.202 6.61186L16.4787 7.2219L17.0887 4.94519"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  saveSvg: (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.16669 6.5C4.16669 5.09987 4.16669 4.3998 4.43917 3.86502C4.67885 3.39462 5.06131 3.01217 5.53171 2.77248C6.06649 2.5 6.76656 2.5 8.16669 2.5H11.8334C13.2335 2.5 13.9336 2.5 14.4683 2.77248C14.9387 3.01217 15.3212 3.39462 15.5609 3.86502C15.8334 4.3998 15.8334 5.09987 15.8334 6.5V17.5L10 14.1667L4.16669 17.5V6.5Z"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  filledSaveSvg: (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="white" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.16669 6.5C4.16669 5.09987 4.16669 4.3998 4.43917 3.86502C4.67885 3.39462 5.06131 3.01217 5.53171 2.77248C6.06649 2.5 6.76656 2.5 8.16669 2.5H11.8334C13.2335 2.5 13.9336 2.5 14.4683 2.77248C14.9387 3.01217 15.3212 3.39462 15.5609 3.86502C15.8334 4.3998 15.8334 5.09987 15.8334 6.5V17.5L10 14.1667L4.16669 17.5V6.5Z"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  primarysaveSvg: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.16663 6.5C4.16663 5.09987 4.16663 4.3998 4.43911 3.86502C4.67879 3.39462 5.06124 3.01217 5.53165 2.77248C6.06643 2.5 6.76649 2.5 8.16663 2.5H11.8333C13.2334 2.5 13.9335 2.5 14.4683 2.77248C14.9387 3.01217 15.3211 3.39462 15.5608 3.86502C15.8333 4.3998 15.8333 5.09987 15.8333 6.5V17.5L9.99996 14.1667L4.16663 17.5V6.5Z"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  downArrow: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 7.5L10 12.5L15 7.5"
        stroke="#98A2B3"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  leftArrow: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 10H5M5 10L9 6M5 10L9 14"
        stroke="#98A2B3"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  rightArrow: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 10H15M15 10L11 6M15 10L11 14"
        stroke="#98A2B3"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  chevronLeftDouble: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 17L13 12L18 7M11 17L6 12L11 7"
        stroke="#98A2B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  chevronRightDouble: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 17L11 12L6 7M13 17L18 12L13 7"
        stroke="#98A2B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  crossArrow: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.1666 5.8335L5.83331 14.1668M5.83331 5.8335L14.1666 14.1668"
        stroke="#98A2B3"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  crossCurrentArrow: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.1666 5.8335L5.83331 14.1668M5.83331 5.8335L14.1666 14.1668"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  smallCrossSvg: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.5 3.5L3.5 8.5M3.5 3.5L8.5 8.5"
        stroke="#98A2B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  questionSvg: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10104_100599)">
        <path
          d="M6.06001 6.00016C6.21675 5.55461 6.52611 5.1789 6.93331 4.93958C7.34052 4.70027 7.81927 4.61279 8.28479 4.69264C8.75032 4.77249 9.17255 5.01451 9.47673 5.37585C9.7809 5.73718 9.94738 6.19451 9.94668 6.66683C9.94668 8.00016 7.94668 8.66683 7.94668 8.66683M8.00001 11.3335H8.00668M14.6667 8.00016C14.6667 11.6821 11.6819 14.6668 8.00001 14.6668C4.31811 14.6668 1.33334 11.6821 1.33334 8.00016C1.33334 4.31826 4.31811 1.3335 8.00001 1.3335C11.6819 1.3335 14.6667 4.31826 14.6667 8.00016Z"
          stroke="#98A2B3"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10104_100599">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  verifiedSvg: (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10104_101114)">
        <path
          d="M14.6721 3.36496C14.8525 3.80138 15.1989 4.14828 15.635 
            4.32939L17.1644 4.96287C17.6009 5.14366 17.9476 5.49042 18.1284 
            5.92688C18.3092 6.36334 18.3092 6.85373 18.1284 7.29019L17.4954 
            8.81846C17.3145 9.25511 17.3143 9.746 17.4959 10.1824L18.1279 11.7103C18.2175 
            11.9264 18.2637 12.1581 18.2637 12.3922C18.2637 12.6262 18.2177 12.8579 18.1281 
            13.0741C18.0385 13.2903 17.9073 13.4867 17.7418 13.6522C17.5763 13.8176 17.3798 
            13.9488 17.1636 14.0383L15.6353 14.6713C15.1989 14.8518 14.852 15.1982 14.6709 
            15.6343L14.0374 17.1637C13.8566 17.6002 13.5098 17.9469 13.0734 18.1277C12.6369 
            18.3085 12.1465 18.3085 11.7101 18.1277L10.1818 17.4947C9.74533 17.3143 9.25511 
            17.3147 8.81891 17.4957L7.28954 18.1283C6.85333 18.3086 6.36336 18.3085 5.92726 
            18.1278C5.49116 17.9472 5.14459 17.6009 4.96368 17.1649L4.33001 15.635C4.14955 
            15.1986 3.80317 14.8517 3.36702 14.6706L1.83766 14.0371C1.40139 13.8564 1.05473 
            13.5099 0.873878 13.0737C0.693025 12.6375 0.69278 12.1473 0.873196 11.7109L1.50623 
            10.1826C1.68657 9.74618 1.6862 9.25595 1.5052 8.81976L0.873081 7.28929C0.783458 
            7.07312 0.73731 6.84141 0.737273 6.6074C0.737235 6.37338 0.783309 6.14166 
            0.872862 5.92546C0.962415 5.70926 1.09369 5.51282 1.25919 5.34738C1.42469 
            5.18193 1.62117 5.05072 1.8374 4.96123L3.36567 4.3282C3.80171 4.14791 4.1484 
            3.80197 4.32964 3.36632L4.96313 1.83695C5.14391 1.40049 5.49068 1.05373 5.92713 
            0.872946C6.36359 0.692159 6.85398 0.692159 7.29044 0.872946L8.81871 1.50598C9.25518 
            1.68632 9.7454 1.68595 10.1816 1.50495L11.7116 0.873927C12.148 0.693242 
            12.6383 0.693279 13.0747 0.87403C13.511 1.05478 13.8578 1.40144 14.0386 1.83779L14.6722 3.36761L14.6721 3.36496Z"
          fill="#29CC39"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.2207 7.00931C13.3477 6.80995 13.3902 6.56834 13.339 
            6.33762C13.2878 6.1069 13.147 5.90599 12.9476 5.77906C12.7483 
            5.65214 12.5066 5.60961 12.2759 5.66083C12.0452 5.71205 
            11.8443 5.85283 11.7174 6.05219L8.22969 11.5325L6.63369 
            9.5375C6.48613 9.35294 6.27131 9.23456 6.03647 9.20839C5.80164 
            9.18222 5.56602 9.25042 5.38147 9.39797C5.19691 9.54552 5.07853 
            9.76034 5.05236 9.99518C5.02619 10.23 5.09438 10.4656 5.24194 
            10.6502L7.61694 13.6189C7.70545 13.7297 7.81913 13.8178 7.94853 
            13.8757C8.07793 13.9337 8.2193 13.96 8.36089 13.9523C8.50248 13.9447 
            8.64019 13.9033 8.76257 13.8317C8.88495 13.7601 8.98846 13.6602 9.0645 13.5406L13.2207 7.00931Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_10104_101114">
          <rect width="19" height="19" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  whatsappSvg: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 17.4375C13.3492 17.4375 16.875 13.9117 16.875 9.5625C16.875 5.21326 13.3492 1.6875 9 1.6875C4.65076 1.6875 1.125 5.21326 1.125 9.5625C1.125 10.9749 1.49681 12.3004 2.14789 13.4465L1.125 17.4375L5.23961 16.4834C6.35702 17.0918 7.63814 17.4375 9 17.4375ZM9 16.226C12.6801 16.226 15.6635 13.2426 15.6635 9.5625C15.6635 5.88237 12.6801 2.89904 9 2.89904C5.31987 2.89904 2.33654 5.88237 2.33654 9.5625C2.33654 10.9834 2.78128 12.3004 3.53916 13.382L2.94231 15.6202L5.21996 15.0508C6.29402 15.7919 7.59632 16.226 9 16.226Z"
        fill="#BFC8D0"
      />
      <path
        d="M15.75 9C15.75 12.7279 12.7279 15.75 9 15.75C7.57809 15.75 6.25887 15.3103 5.17087 14.5596L2.86364 15.1364L3.46824 12.8691C2.70052 11.7735 2.25 10.4394 2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9Z"
        fill="url(#paint0_linear_10104_101082)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 16.875C13.3492 16.875 16.875 13.3492 16.875 9C16.875 4.65076 13.3492 1.125 9 1.125C4.65076 1.125 1.125 4.65076 1.125 9C1.125 10.4124 1.49681 11.7379 2.14789 12.884L1.125 16.875L5.23961 15.9209C6.35702 16.5293 7.63814 16.875 9 16.875ZM9 15.6635C12.6801 15.6635 15.6635 12.6801 15.6635 9C15.6635 5.31987 12.6801 2.33654 9 2.33654C5.31987 2.33654 2.33654 5.31987 2.33654 9C2.33654 10.4209 2.78128 11.7379 3.53916 12.8195L2.94231 15.0577L5.21996 14.4883C6.29402 15.2294 7.59632 15.6635 9 15.6635Z"
        fill="white"
      />
      <path
        d="M7.03126 5.34353C6.84403 4.96746 6.5568 5.00075 6.26663 5.00075C5.74805 5.00075 4.93945 5.62191 4.93945 6.77795C4.93945 7.72538 5.35694 8.76249 6.76373 10.3139C8.1214 11.8112 9.90528 12.5857 11.3862 12.5593C12.8672 12.5329 13.1719 11.2585 13.1719 10.8282C13.1719 10.6374 13.0535 10.5422 12.972 10.5164C12.4673 10.2742 11.5365 9.82287 11.3247 9.73807C11.1129 9.65328 11.0023 9.76797 10.9336 9.83036C10.7415 10.0134 10.3608 10.5528 10.2305 10.6741C10.1001 10.7954 9.90578 10.734 9.82491 10.6882C9.52731 10.5687 8.7204 10.2098 8.0772 9.58632C7.28174 8.81522 7.23506 8.54993 7.08519 8.31377C6.9653 8.12485 7.05328 8.00893 7.09718 7.95828C7.26857 7.76053 7.50522 7.45522 7.61134 7.30349C7.71747 7.15177 7.63322 6.92142 7.58266 6.77795C7.36525 6.16092 7.18105 5.64439 7.03126 5.34353Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10104_101082"
          x1="14.9062"
          y1="3.9375"
          x2="2.25"
          y2="15.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5BD066" />
          <stop offset="1" stopColor="#27B43E" />
        </linearGradient>
      </defs>
    </svg>
  ),
  slackSvg: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.9064 8.43726C15.683 8.43726 16.3125 7.80771 16.3125 7.03113C16.3125 6.25455 15.6829 5.625 14.9063 5.625C14.1297 5.625 13.5 6.2546 13.5 7.03125V8.43726H14.9064ZM10.9688 8.43726C11.7454 8.43726 12.375 7.80766 12.375 7.03101V3.09375C12.375 2.3171 11.7454 1.6875 10.9688 1.6875C10.1921 1.6875 9.5625 2.3171 9.5625 3.09375V7.03101C9.5625 7.80766 10.1921 8.43726 10.9688 8.43726Z"
        fill="#2EB67D"
      />
      <path
        d="M3.09363 9.56274C2.31705 9.56274 1.6875 10.1923 1.6875 10.9689C1.6875 11.7455 2.31711 12.375 3.09369 12.375C3.87034 12.375 4.5 11.7454 4.5 10.9687V9.56274H3.09363ZM7.03125 9.56274C6.2546 9.56274 5.625 10.1923 5.625 10.969V14.9062C5.625 15.6829 6.2546 16.3125 7.03125 16.3125C7.8079 16.3125 8.4375 15.6829 8.4375 14.9063V10.969C8.4375 10.1923 7.8079 9.56274 7.03125 9.56274Z"
        fill="#E01E5A"
      />
      <path
        d="M9.5626 14.9064C9.5626 15.683 10.1921 16.3125 10.9687 16.3125C11.7453 16.3125 12.3749 15.6829 12.3749 14.9063C12.3749 14.1297 11.7453 13.5 10.9686 13.5L9.5626 13.5L9.5626 14.9064ZM9.5626 10.9687C9.5626 11.7454 10.1922 12.375 10.9689 12.375L14.9061 12.375C15.6828 12.375 16.3124 11.7454 16.3124 10.9687C16.3124 10.1921 15.6828 9.5625 14.9061 9.5625L10.9689 9.5625C10.1922 9.5625 9.5626 10.1921 9.5626 10.9687Z"
        fill="#ECB22E"
      />
      <path
        d="M8.43736 3.09363C8.43736 2.31705 7.80782 1.6875 7.03123 1.6875C6.25465 1.6875 5.6251 2.31711 5.6251 3.09369C5.6251 3.87034 6.2547 4.5 7.03135 4.5L8.43736 4.5L8.43736 3.09363ZM8.43736 7.03125C8.43736 6.2546 7.80776 5.625 7.03111 5.625L3.09385 5.625C2.3172 5.625 1.6876 6.2546 1.6876 7.03125C1.6876 7.8079 2.3172 8.4375 3.09385 8.4375L7.03111 8.4375C7.80776 8.4375 8.43736 7.8079 8.43736 7.03125Z"
        fill="#36C5F0"
      />
    </svg>
  ),
  linkedinSvg: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1.125" y="1.125" width="15.75" height="15.75" rx="7.875" fill="#1275B1" />
      <path
        d="M7.09794 5.45183C7.09794 5.97752 6.64229 6.40367 6.08022 6.40367C5.51815 6.40367 5.0625 5.97752 5.0625 5.45183C5.0625 4.92615 5.51815 4.5 6.08022 4.5C6.64229 4.5 7.09794 4.92615 7.09794 5.45183Z"
        fill="white"
      />
      <path d="M5.20168 7.10331H6.94137V12.375H5.20168V7.10331Z" fill="white" />
      <path
        d="M9.74227 7.10331H8.00258V12.375H9.74227C9.74227 12.375 9.74227 10.7154 9.74227 9.67773C9.74227 9.05491 9.95493 8.42936 10.8035 8.42936C11.7624 8.42936 11.7567 9.24442 11.7522 9.87586C11.7464 10.7012 11.7603 11.5435 11.7603 12.375H13.5V9.59272C13.4853 7.81615 13.0223 6.99755 11.4994 6.99755C10.5949 6.99755 10.0343 7.40816 9.74227 7.77965V7.10331Z"
        fill="white"
      />
    </svg>
  ),
  mailBigSvg: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.125 13.5L11.1429 9M6.85714 9L1.87503 13.5M1.5 5.25L7.62369 9.53658C8.11957 9.8837 8.36751 10.0573 8.6372 10.1245C8.87542 10.1839 9.12458 10.1839 9.3628 10.1245C9.63249 10.0573 9.88043 9.8837 10.3763 9.53658L16.5 5.25M5.1 15H12.9C14.1601 15 14.7902 15 15.2715 14.7548C15.6948 14.539 16.039 14.1948 16.2548 13.7715C16.5 13.2902 16.5 12.6601 16.5 11.4V6.6C16.5 5.33988 16.5 4.70982 16.2548 4.22852C16.039 3.80516 15.6948 3.46095 15.2715 3.24524C14.7902 3 14.1601 3 12.9 3H5.1C3.83988 3 3.20982 3 2.72852 3.24524C2.30516 3.46095 1.96095 3.80516 1.74524 4.22852C1.5 4.70982 1.5 5.33988 1.5 6.6V11.4C1.5 12.6601 1.5 13.2902 1.74524 13.7715C1.96095 14.1948 2.30516 14.539 2.72852 14.7548C3.20982 15 3.83988 15 5.1 15Z"
        stroke="#475467"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  plusSvg: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99996 4.1665V15.8332M4.16663 9.99984H15.8333"
        stroke="#D0D5DD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  plusIcon: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99996 4.1665V15.8332M4.16663 9.99984H15.8333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  bluePlusSvg: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 2.5V9.5M2.5 6H9.5"
        stroke="#0BA5EC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  roundedplusSvg: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="19"
        height="19"
        rx="9.5"
        stroke="#E4E7EC"
        strokeLinecap="square"
      />
      <path
        d="M10 6V14M6 10H14"
        stroke="#D0D5DD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  mediumRoundedPlusSvg: (
    <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="19"
        height="19"
        rx="9.5"
        stroke="#E4E7EC"
        strokeLinecap="square"
      />
      <path
        d="M10 6V14M6 10H14"
        stroke="#D0D5DD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  mediumRoundedPlusTalentPoolSvg: (
    <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="19"
        height="19"
        rx="9.5"
        stroke="#6f6f6f"
        strokeLinecap="square"
      />
      <path
        d="M10 6V14M6 10H14"
        stroke="#6f6f6f"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  heartSvg: (
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="31" height="31" rx="15.5" fill="#F9F5FF" />
      <path
        d="M22.7246 11.4842C22.489 10.9386 22.1493 10.4443 21.7244 10.0287C21.2993 9.61196 20.798 
          9.28076 20.2479 9.05314C19.6774 8.81617 19.0656 8.69488 18.4479 8.6963C17.5813 8.6963 16.7357 
          8.93361 16.001 9.38185C15.8252 9.48907 15.6582 9.60685 15.5 9.73517C15.3418 9.60685 15.1748 
          9.48907 14.999 9.38185C14.2643 8.93361 13.4187 8.6963 12.5521 8.6963C11.9281 8.6963 11.3234 
          8.81583 10.7521 9.05314C10.2002 9.28165 9.70273 9.61036 9.27559 10.0287C8.85019 10.4438 8.51037 
          10.9383 8.27539 11.4842C8.03105 12.052 7.90625 12.6549 7.90625 13.2754C7.90625 13.8608 8.02578 
          14.4707 8.26309 15.0912C8.46172 15.6098 8.74648 16.1477 9.11035 16.6908C9.68691 17.5504 10.4797 
          18.4469 11.4641 19.3557C13.0953 20.8621 14.7107 21.9027 14.7793 21.9449L15.1959 22.2121C15.3805 
          22.3299 15.6178 22.3299 15.8023 22.2121L16.2189 21.9449C16.2875 21.901 17.9012 20.8621 19.5342 
          19.3557C20.5186 18.4469 21.3113 17.5504 21.8879 16.6908C22.2518 16.1477 22.5383 15.6098 22.7352 
          15.0912C22.9725 14.4707 23.092 13.8608 23.092 13.2754C23.0938 12.6549 22.9689 12.052 22.7246 
          11.4842ZM15.5 20.8217C15.5 20.8217 9.24219 16.8121 9.24219 13.2754C9.24219 11.4842 10.724 
          10.0322 12.5521 10.0322C13.8371 10.0322 14.9516 10.7494 15.5 11.7971C16.0484 10.7494 17.1629 
          10.0322 18.4479 10.0322C20.276 10.0322 21.7578 11.4842 21.7578 13.2754C21.7578 16.8121 15.5 
          20.8217 15.5 20.8217Z"
        fill="#6941C6"
      />
    </svg>
  ),
  downthumbSvg: (
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.9025 9V16.7M23.5 14.46V11.24C23.5 10.4559 23.5 10.0639 23.3432 9.76441C23.2052 9.50099 22.9851 9.28681 22.7143 9.15259C22.4065 9 22.0035 9 21.1976 9H13.512C12.4604 9 11.9347 9 11.51 9.1872C11.1357 9.3522 10.8177 9.6177 10.5931 9.9525C10.3384 10.3324 10.2584 10.8379 10.0985 11.8491L9.72219 14.2291C9.5113 15.5627 9.40586 16.2295 9.60927 16.7484C9.7878 17.2038 10.1236 17.5846 10.5591 17.8255C11.0553 18.1 11.7487 18.1 13.1356 18.1H13.7149C14.1178 18.1 14.3193 18.1 14.4732 18.1763C14.6086 18.2434 14.7186 18.3505 14.7876 18.4822C14.866 18.6319 14.866 18.828 14.866 19.22V21.2739C14.866 22.2272 15.6604 23 16.6402 23C16.8739 23 17.0857 22.8661 17.1806 22.6583L19.5987 17.3651C19.7087 17.1244 19.7636 17.004 19.8506 16.9157C19.9274 16.8377 20.0218 16.7781 20.1262 16.7414C20.2445 16.7 20.3799 16.7 20.6506 16.7H21.1976C22.0035 16.7 22.4065 16.7 22.7143 16.5474C22.9851 16.4132 23.2052 16.199 23.3432 15.9356C23.5 15.6361 23.5 15.2441 23.5 14.46Z"
        stroke="#667085"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  shareSvg: (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9425 16.6325L18.065 19.6175M18.0575 11.3825L12.9425 14.3675M22.25 10.25C22.25 11.4926 21.2426 12.5 20 12.5C18.7574 12.5 17.75 11.4926 17.75 10.25C17.75 9.00736 18.7574 8 20 8C21.2426 8 22.25 9.00736 22.25 10.25ZM13.25 15.5C13.25 16.7426 12.2426 17.75 11 17.75C9.75736 17.75 8.75 16.7426 8.75 15.5C8.75 14.2574 9.75736 13.25 11 13.25C12.2426 13.25 13.25 14.2574 13.25 15.5ZM22.25 20.75C22.25 21.9926 21.2426 23 20 23C18.7574 23 17.75 21.9926 17.75 20.75C17.75 19.5074 18.7574 18.5 20 18.5C21.2426 18.5 22.25 19.5074 22.25 20.75Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  primaryShareSvg: (
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.9425 16.6325L18.065 19.6175M18.0575 11.3825L12.9425 14.3675M22.25 10.25C22.25 11.4926 21.2426 12.5 20 12.5C18.7574 12.5 17.75 11.4926 17.75 10.25C17.75 9.00736 18.7574 8 20 8C21.2426 8 22.25 9.00736 22.25 10.25ZM13.25 15.5C13.25 16.7426 12.2426 17.75 11 17.75C9.75736 17.75 8.75 16.7426 8.75 15.5C8.75 14.2574 9.75736 13.25 11 13.25C12.2426 13.25 13.25 14.2574 13.25 15.5ZM22.25 20.75C22.25 21.9926 21.2426 23 20 23C18.7574 23 17.75 21.9926 17.75 20.75C17.75 19.5074 18.7574 18.5 20 18.5C21.2426 18.5 22.25 19.5074 22.25 20.75Z"
        stroke="#53389E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  dottedmenuSvg: (
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.5 16.25C15.9142 16.25 16.25 15.9142 16.25 15.5C16.25 15.0858 15.9142 14.75 15.5 14.75C15.0858 14.75 14.75 15.0858 14.75 15.5C14.75 15.9142 15.0858 16.25 15.5 16.25Z"
        stroke="#667085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 11C15.9142 11 16.25 10.6642 16.25 10.25C16.25 9.83579 15.9142 9.5 15.5 9.5C15.0858 9.5 14.75 9.83579 14.75 10.25C14.75 10.6642 15.0858 11 15.5 11Z"
        stroke="#667085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 21.5C15.9142 21.5 16.25 21.1642 16.25 20.75C16.25 20.3358 15.9142 20 15.5 20C15.0858 20 14.75 20.3358 14.75 20.75C14.75 21.1642 15.0858 21.5 15.5 21.5Z"
        stroke="#667085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  checkCircleSvg: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10104_105342)">
        <path
          d="M18.3333 9.23843V10.0051C18.3323 11.8021 17.7504 13.5507 16.6745 14.99C15.5985 16.4292 14.0861 17.4822 12.3628 17.9917C10.6395 18.5012 8.79772 18.44 7.11206 17.8172C5.42641 17.1945 3.98722 16.0435 3.00914 14.536C2.03106 13.0285 1.5665 11.2451 1.68474 9.45202C1.80297 7.6589 2.49768 5.95203 3.66524 4.58599C4.8328 3.21994 6.41066 2.26791 8.1635 1.87188C9.91633 1.47585 11.7502 1.65704 13.3917 2.38843M18.3333 3.33366L10 11.6753L7.50001 9.17533"
          stroke="#98A2B3"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10104_105342">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  checkIcon: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.6666 5L7.49992 14.1667L3.33325 10"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  smalluparrowSvg: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.66669 11.3337L11.3334 4.66699M11.3334 4.66699H4.66669M11.3334 4.66699V11.3337"
        stroke="#B692F6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  stopwatch: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00001 6.33301V8.99967L9.66668 9.99967M8.00001 3.33301C4.8704 3.33301 2.33334 5.87006 2.33334 8.99967C2.33334 12.1293 4.8704 14.6663 8.00001 14.6663C11.1296 14.6663 13.6667 12.1293 13.6667 8.99967C13.6667 5.87006 11.1296 3.33301 8.00001 3.33301ZM8.00001 3.33301V1.33301M6.66668 1.33301H9.33334M13.5527 3.7277L12.5527 2.7277L13.0527 3.2277M2.44736 3.7277L3.44736 2.7277L2.94736 3.2277"
        stroke="#D0D5DD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  primaryArrowSvg: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.66666 11.3337L11.3333 4.66699M11.3333 4.66699H4.66666M11.3333 4.66699V11.3337"
        stroke="#B692F6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  arrowSvg: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.66666 11.3337L11.3333 4.66699M11.3333 4.66699H4.66666M11.3333 4.66699V11.3337"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  closeIcon: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 5L5 11M5 5L11 11"
        stroke="#98A2B3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  checkIconWithBg: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H12C13.933 0.5 15.5 2.067 15.5 4V12C15.5 13.933 13.933 15.5 12 15.5H4C2.067 15.5 0.5 13.933 0.5 12V4Z"
        fill="#7F56D9"
      />
      <path
        d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H12C13.933 0.5 15.5 2.067 15.5 4V12C15.5 13.933 13.933 15.5 12 15.5H4C2.067 15.5 0.5 13.933 0.5 12V4Z"
        stroke="#7F56D9"
      />
      <path
        d="M12 5L6.5 10.5L4 8"
        stroke="white"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  smallCheckIconWithBg: (
    <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H12C13.933 0.5 15.5 2.067 15.5 4V12C15.5 13.933 13.933 15.5 12 15.5H4C2.067 15.5 0.5 13.933 0.5 12V4Z"
        fill="#7F56D9"
      />
      <path
        d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H12C13.933 0.5 15.5 2.067 15.5 4V12C15.5 13.933 13.933 15.5 12 15.5H4C2.067 15.5 0.5 13.933 0.5 12V4Z"
        stroke="#7F56D9"
      />
      <path
        d="M12 5L6.5 10.5L4 8"
        stroke="white"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  mailSvg: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.5 2.5H1.5C1.22344 2.5 1 2.72344 1 3V13C1 13.2766 1.22344 13.5 1.5 13.5H14.5C14.7766 13.5 15 13.2766 15 13V3C15 2.72344 14.7766 2.5 14.5 2.5ZM13.875 4.23125V12.375H2.125V4.23125L1.69375 3.89531L2.30781 3.10625L2.97656 3.62656H13.025L13.6938 3.10625L14.3078 3.89531L13.875 4.23125ZM13.025 3.625L8 7.53125L2.975 3.625L2.30625 3.10469L1.69219 3.89375L2.12344 4.22969L7.46094 8.37969C7.61444 8.49894 7.80328 8.56367 7.99766 8.56367C8.19203 8.56367 8.38088 8.49894 8.53438 8.37969L13.875 4.23125L14.3062 3.89531L13.6922 3.10625L13.025 3.625Z"
        fill="#667085"
      />
    </svg>
  ),
  phoneSvg: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.7047 3.72969L12.0406 2.06719C11.8375 1.86406 11.5656 1.75 11.2781 1.75C10.9906 1.75 10.7188 1.8625 10.5156 2.06719L8.72344 3.85625C8.52031 4.05937 8.40625 4.33281 8.40625 4.62031C8.40625 4.90937 8.51875 5.17969 8.72344 5.38437L10.1234 6.78594C9.80451 7.52904 9.34626 8.20421 8.77344 8.775C8.2 9.35156 7.52969 9.80625 6.78594 10.1281L5.38594 8.72656C5.18281 8.52344 4.91094 8.40937 4.62344 8.40937C4.48163 8.40885 4.34114 8.43663 4.21021 8.4911C4.07928 8.54557 3.96054 8.62562 3.86094 8.72656L2.06719 10.5156C1.86406 10.7187 1.75 10.9922 1.75 11.2797C1.75 11.5687 1.8625 11.8391 2.06719 12.0437L3.72969 13.7062C4.07656 14.0531 4.55469 14.2516 5.04531 14.2516C5.14687 14.2516 5.24531 14.2437 5.34531 14.2266C7.41406 13.8859 9.46719 12.7844 11.125 11.1281C12.7812 9.46875 13.8813 7.41562 14.225 5.34531C14.3234 4.75781 14.1266 4.15312 13.7047 3.72969ZM13.1172 5.15937C12.8125 7.00156 11.8219 8.83906 10.3297 10.3312C8.8375 11.8234 7.00156 12.8141 5.15938 13.1187C4.92813 13.1578 4.69062 13.0797 4.52187 12.9125L2.88906 11.2797L4.62031 9.54687L6.49219 11.4219L6.50625 11.4359L6.84375 11.3109C7.86707 10.9347 8.79635 10.3404 9.56717 9.56934C10.338 8.79825 10.9319 7.86877 11.3078 6.84531L11.4328 6.50781L9.54531 4.62187L11.2766 2.88906L12.9094 4.52187C13.0781 4.69062 13.1562 4.92812 13.1172 5.15937Z"
        fill="#667085"
      />
    </svg>
  ),
  whiteMailSvg: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.9166 14.9997L12.3809 9.99967M7.61904 9.99967L2.08335 14.9997M1.66666 5.83301L8.47076 10.5959C9.02173 10.9816 9.29722 11.1744 9.59688 11.2491C9.86157 11.3151 10.1384 11.3151 10.4031 11.2491C10.7028 11.1744 10.9782 10.9816 11.5292 10.5959L18.3333 5.83301M5.66666 16.6663H14.3333C15.7335 16.6663 16.4335 16.6663 16.9683 16.3939C17.4387 16.1542 17.8212 15.7717 18.0608 15.3013C18.3333 14.7665 18.3333 14.0665 18.3333 12.6663V7.33301C18.3333 5.93288 18.3333 5.23281 18.0608 4.69803C17.8212 4.22763 17.4387 3.84517 16.9683 3.60549C16.4335 3.33301 15.7335 3.33301 14.3333 3.33301H5.66666C4.26653 3.33301 3.56646 3.33301 3.03168 3.60549C2.56128 3.84517 2.17882 4.22763 1.93914 4.69803C1.66666 5.23281 1.66666 5.93288 1.66666 7.33301V12.6663C1.66666 14.0665 1.66666 14.7665 1.93914 15.3013C2.17882 15.7717 2.56128 16.1542 3.03168 16.3939C3.56646 16.6663 4.26653 16.6663 5.66666 16.6663Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  blackStarSvg: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_238_45756)">
        <path
          d="M3.75002 18.3337V14.167M3.75002 5.83366V1.66699M1.66669 3.75033H5.83335M1.66669 16.2503H5.83335M10.8334 2.50033L9.38821 6.25771C9.1532 6.86874 9.03569 7.17425 8.85296 7.43123C8.69101 7.65899 8.49202 7.85798 8.26426 8.01993C8.00728 8.20266 7.70176 8.32017 7.09074 8.55518L3.33335 10.0003L7.09074 11.4455C7.70176 11.6805 8.00728 11.798 8.26426 11.9807C8.49202 12.1427 8.69101 12.3417 8.85296 12.5694C9.03569 12.8264 9.1532 13.1319 9.38821 13.7429L10.8334 17.5003L12.2785 13.7429C12.5135 13.1319 12.631 12.8264 12.8137 12.5694C12.9757 12.3417 13.1747 12.1427 13.4025 11.9807C13.6594 11.798 13.9649 11.6805 14.576 11.4455L18.3334 10.0003L14.576 8.55518C13.9649 8.32017 13.6594 8.20266 13.4024 8.01993C13.1747 7.85798 12.9757 7.65899 12.8137 7.43123C12.631 7.17425 12.5135 6.86874 12.2785 6.25771L10.8334 2.50033Z"
          stroke="currentColor"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_238_45756">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  upRightArrowSvg: (
    <svg width="40" height="40" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.5834 35.4163L35.4167 14.583M35.4167 14.583H14.5834M35.4167 14.583V35.4163"
        stroke="#94969C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  arrowNarrowLeft: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.6667 10H3.33333M3.33333 10L8.33333 15M3.33333 10L8.33333 5"
        stroke="#98A2B3"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  switchIconSvg: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.1667 3.33301V16.6663M14.1667 16.6663L10.8333 13.333M14.1667 16.6663L17.5 13.333M5.83333 16.6663V3.33301M5.83333 3.33301L2.5 6.66634M5.83333 3.33301L9.16667 6.66634"
        stroke="#53389E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  copySvg: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.25 2.5H12.1667C14.0335 2.5 14.9669 2.5 15.68 2.86331C16.3072 3.18289 16.8171 3.69282 17.1367 4.32003C17.5 5.03307 17.5 5.96649 17.5 7.83333V13.75M5.16667 17.5H11.9167C12.8501 17.5 13.3168 17.5 13.6733 17.3183C13.9869 17.1586 14.2419 16.9036 14.4017 16.59C14.5833 16.2335 14.5833 15.7668 14.5833 14.8333V8.08333C14.5833 7.14991 14.5833 6.6832 14.4017 6.32668C14.2419 6.01308 13.9869 5.75811 13.6733 5.59832C13.3168 5.41667 12.8501 5.41667 11.9167 5.41667H5.16667C4.23325 5.41667 3.76654 5.41667 3.41002 5.59832C3.09641 5.75811 2.84144 6.01308 2.68166 6.32668C2.5 6.6832 2.5 7.14991 2.5 8.08333V14.8333C2.5 15.7668 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76654 17.5 4.23325 17.5 5.16667 17.5Z"
        stroke="#53389E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  copyCurrentSvg: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.7474 1.6703C8.18485 1.67792 7.84715 1.71049 7.57408 1.84962C7.26048 2.00941 7.00551 2.26438 6.84572 2.57798C6.70658 2.85105 6.67402 3.18876 6.66639 3.7513M16.2474 1.6703C16.8099 1.67792 17.1476 1.71049 17.4207 1.84962C17.7343 2.00941 17.9893 2.26438 18.1491 2.57798C18.2882 2.85105 18.3208 3.18876 18.3284 3.75129M18.3284 11.2513C18.3208 11.8138 18.2882 12.1516 18.1491 12.4246C17.9893 12.7382 17.7343 12.9932 17.4207 13.153C17.1476 13.2921 16.8099 13.3247 16.2474 13.3323M18.3307 6.66796V8.33463M11.6641 1.66797H13.3307M4.33073 18.3346H10.6641C11.5975 18.3346 12.0642 18.3346 12.4207 18.153C12.7343 17.9932 12.9893 17.7382 13.1491 17.4246C13.3307 17.0681 13.3307 16.6014 13.3307 15.668V9.33463C13.3307 8.40121 13.3307 7.9345 13.1491 7.57798C12.9893 7.26438 12.7343 7.00941 12.4207 6.84962C12.0642 6.66797 11.5975 6.66797 10.6641 6.66797H4.33073C3.39731 6.66797 2.9306 6.66797 2.57408 6.84962C2.26047 7.00941 2.00551 7.26438 1.84572 7.57798C1.66406 7.9345 1.66406 8.40121 1.66406 9.33463V15.668C1.66406 16.6014 1.66406 17.0681 1.84572 17.4246C2.00551 17.7382 2.26047 17.9932 2.57408 18.153C2.9306 18.3346 3.39731 18.3346 4.33073 18.3346Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  primaryDeleteSvg: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5"
        stroke="#53389E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  userSvg: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.6668 17.5C16.6668 16.337 16.6668 15.7555 16.5233 15.2824C16.2001 14.217 15.3664 13.3834 14.3011 13.0602C13.828 12.9167 13.2465 12.9167 12.0835 12.9167H7.91683C6.75386 12.9167 6.17237 12.9167 5.69921 13.0602C4.63388 13.3834 3.8002 14.217 3.47703 15.2824C3.3335 15.7555 3.3335 16.337 3.3335 17.5M13.7502 6.25C13.7502 8.32107 12.0712 10 10.0002 10C7.92909 10 6.25016 8.32107 6.25016 6.25C6.25016 4.17893 7.92909 2.5 10.0002 2.5C12.0712 2.5 13.7502 4.17893 13.7502 6.25Z"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  uploadSvg: (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dii_108_14200)">
        <path
          d="M2 9C2 4.58172 5.58172 1 10 1H34C38.4183 1 42 4.58172 42 9V33C42 37.4183 38.4183 41 34 41H10C5.58172 41 2 37.4183 2 33V9Z"
          fill="white"
        />
        <path
          d="M2.5 9C2.5 4.85786 5.85786 1.5 10 1.5H34C38.1421 1.5 41.5 4.85786 41.5 9V33C41.5 37.1421 38.1421 40.5 34 40.5H10C5.85786 40.5 2.5 37.1421 2.5 33V9Z"
          stroke="#E4E7EC"
        />
        <path
          d="M18.6665 24.3333L21.9998 21M21.9998 21L25.3332 24.3333M21.9998 21V28.5M28.6665 24.9524C29.6844 24.1117 30.3332 22.8399 30.3332 21.4167C30.3332 18.8854 28.2811 16.8333 25.7498 16.8333C25.5677 16.8333 25.3974 16.7383 25.3049 16.5814C24.2182 14.7374 22.2119 13.5 19.9165 13.5C16.4647 13.5 13.6665 16.2982 13.6665 19.75C13.6665 21.4718 14.3627 23.0309 15.489 24.1613"
          stroke="#344054"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_dii_108_14200"
          x="0"
          y="0"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_108_14200" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_108_14200"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.18 0"
          />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_108_14200" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect3_innerShadow_108_14200"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_108_14200"
            result="effect3_innerShadow_108_14200"
          />
        </filter>
      </defs>
    </svg>
  ),
  intersectSquare: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_10214_21427)">
        <path
          d="M1.6665 4.33317C1.6665 3.39975 1.6665 2.93304 1.84816 2.57652C2.00795 2.26292 2.26292 2.00795 2.57652 1.84816C2.93304 1.6665 3.39975 1.6665 4.33317 1.6665H10.6665C11.5999 1.6665 12.0666 1.6665 12.4232 1.84816C12.7368 2.00795 12.9917 2.26292 13.1515 2.57652C13.3332 2.93304 13.3332 3.39975 13.3332 4.33317V10.6665C13.3332 11.5999 13.3332 12.0666 13.1515 12.4232C12.9917 12.7368 12.7368 12.9917 12.4232 13.1515C12.0666 13.3332 11.5999 13.3332 10.6665 13.3332H4.33317C3.39975 13.3332 2.93304 13.3332 2.57652 13.1515C2.26292 12.9917 2.00795 12.7368 1.84816 12.4232C1.6665 12.0666 1.6665 11.5999 1.6665 10.6665V4.33317Z"
          stroke="#98A2B3"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.6665 9.33317C6.6665 8.39975 6.6665 7.93304 6.84816 7.57652C7.00795 7.26292 7.26292 7.00795 7.57652 6.84816C7.93304 6.6665 8.39975 6.6665 9.33317 6.6665H15.6665C16.5999 6.6665 17.0666 6.6665 17.4232 6.84816C17.7368 7.00795 17.9917 7.26292 18.1515 7.57652C18.3332 7.93304 18.3332 8.39975 18.3332 9.33317V15.6665C18.3332 16.5999 18.3332 17.0666 18.1515 17.4232C17.9917 17.7368 17.7368 17.9917 17.4232 18.1515C17.0666 18.3332 16.5999 18.3332 15.6665 18.3332H9.33317C8.39975 18.3332 7.93304 18.3332 7.57652 18.1515C7.26292 17.9917 7.00795 17.7368 6.84816 17.4232C6.6665 17.0666 6.6665 16.5999 6.6665 15.6665V9.33317Z"
          stroke="#98A2B3"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10214_21427">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  primaryCrossSvg: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.1668 5.8335L5.8335 14.1668M5.8335 5.8335L14.1668 14.1668"
        stroke="#7F56D9"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  crossSvg: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.1668 5.8335L5.8335 14.1668M5.8335 5.8335L14.1668 14.1668"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  searchLgSvg: (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5 18L14.5834 15.0833M16.6667 10.0833C16.6667 13.9954 13.4954 17.1667 9.58333 17.1667C5.67132 17.1667 2.5 13.9954 2.5 10.0833C2.5 6.17132 5.67132 3 9.58333 3C13.4954 3 16.6667 6.17132 16.6667 10.0833Z"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  micSvg: (
    <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8115 7.15234H8.52692H8.1958V12.1003L11.1759 15.2811H13.1626L15.8115 12.4537V7.15234Z"
        fill="white"
        fillOpacity="0.8"
      />
      <path
        d="M12.0037 14.8105C14.1075 14.8105 15.8115 13.1316 15.8115 11.0588V5.90015C15.8115 3.82733 14.1075 2.14844 12.0037 2.14844C9.89982 2.14844 8.1958 3.82733 8.1958 5.90015V11.0588C8.1958 13.1316 9.89982 14.8105 12.0037 14.8105Z"
        stroke="white"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.72168 9.32422V10.9187C4.72168 14.8768 7.98693 18.0939 12.0042 18.0939C16.0215 18.0939 19.2868 14.8768 19.2868 10.9187V9.32422"
        stroke="white"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0039 18.0938V20.9075"
        stroke="white"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  orangeStarSvg: (
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 11.1357L3.17414 13.5L4.14015 8.75226L0.5 5.46573L5.42325 4.89561L7.5 0.5L9.57675 4.89561L14.5 5.46573L10.8599 8.75226L11.8259 13.5L7.5 11.1357Z"
        fill="#F79009"
      />
    </svg>
  ),
  primaryEye: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.81509 9.53488C1.71295 9.37315 1.66188 9.29229 1.63329 9.16756C1.61182 9.07387 1.61182 8.92613 1.63329 8.83244C1.66188 8.70771 1.71295 8.62685 1.81509 8.46512C2.65915 7.12863 5.17155 3.75 9.0003 3.75C12.8291 3.75 15.3415 7.12863 16.1855 8.46512C16.2877 8.62685 16.3387 8.70771 16.3673 8.83244C16.3888 8.92613 16.3888 9.07387 16.3673 9.16756C16.3387 9.29229 16.2877 9.37315 16.1855 9.53488C15.3415 10.8714 12.8291 14.25 9.0003 14.25C5.17155 14.25 2.65915 10.8714 1.81509 9.53488Z"
        stroke="#7F56D9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.0003 11.25C10.2429 11.25 11.2503 10.2426 11.2503 9C11.2503 7.75736 10.2429 6.75 9.0003 6.75C7.75766 6.75 6.7503 7.75736 6.7503 9C6.7503 10.2426 7.75766 11.25 9.0003 11.25Z"
        stroke="#7F56D9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  uploadRecordingSvg: (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.70332 20.907H14.4151C19.175 20.907 21.0789 19.0312 21.0789 14.3415V8.71394C21.0789 4.02429 19.175 2.14844 14.4151 2.14844H8.70332C3.94349 2.14844 2.03955 4.02429 2.03955 8.71394V14.3415C2.03955 19.0312 3.94349 20.907 8.70332 20.907Z"
        stroke="#0060FF"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.70361 9.19269L11.5595 6.37891L14.4154 9.19269"
        stroke="#0060FF"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5596 6.37891V13.8823"
        stroke="#0060FF"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.84766 15.7578C9.55081 16.9771 13.5681 16.9771 17.2713 15.7578"
        stroke="#0060FF"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  recordCircleSvg: (
    <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.8883 20.907C17.1459 20.907 21.408 16.7078 21.408 11.5277C21.408 6.34769 17.1459 2.14844 11.8883 2.14844C6.63076 2.14844 2.36865 6.34769 2.36865 11.5277C2.36865 16.7078 6.63076 20.907 11.8883 20.907Z"
        stroke="#EB5757"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.917 15.4954C14.1409 15.4954 15.9438 13.7191 15.9438 11.528C15.9438 9.33683 14.1409 7.56055 11.917 7.56055C9.69301 7.56055 7.89014 9.33683 7.89014 11.528C7.89014 13.7191 9.69301 15.4954 11.917 15.4954Z"
        stroke="#EB5757"
        strokeWidth="2.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="14.4932" cy="14.2734" r="4" fill="#EB5757" fillOpacity="0.6" />
    </svg>
  ),
  messageSvg: (
    <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.94316 18.0932H8.46718C4.65931 18.0932 2.75537 17.1553 2.75537 12.4657V7.77601C2.75537 4.0243 4.65931 2.14844 8.46718 2.14844H16.0829C19.8908 2.14844 21.7947 4.0243 21.7947 7.77601V12.4657C21.7947 16.2174 19.8908 18.0932 16.0829 18.0932H15.6069C15.3118 18.0932 15.0262 18.2339 14.8454 18.4684L13.4174 20.3443C12.7891 21.1696 11.761 21.1696 11.1327 20.3443L9.70473 18.4684C9.55242 18.2621 9.20019 18.0932 8.94316 18.0932Z"
        stroke="#0060FF"
        strokeWidth="2.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0787 10.592H16.0872"
        stroke="#0060FF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2701 10.592H12.2786"
        stroke="#0060FF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.46148 10.592H8.47003"
        stroke="#0060FF"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  roundMenuDotsSvg: (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.5532 9.65234C10.5061 9.65234 9.64931 10.4965 9.64931 11.5282C9.64931 12.5599 10.5061 13.4041 11.5532 13.4041C12.6004 13.4041 13.4572 12.5599 13.4572 11.5282C13.4572 10.4965 12.6004 9.65234 11.5532 9.65234ZM17.265 9.65234C16.2179 9.65234 15.3611 10.4965 15.3611 11.5282C15.3611 12.5599 16.2179 13.4041 17.265 13.4041C18.3122 13.4041 19.169 12.5599 19.169 11.5282C19.169 10.4965 18.3122 9.65234 17.265 9.65234ZM5.84144 9.65234C4.79427 9.65234 3.9375 10.4965 3.9375 11.5282C3.9375 12.5599 4.79427 13.4041 5.84144 13.4041C6.8886 13.4041 7.74537 12.5599 7.74537 11.5282C7.74537 10.4965 6.8886 9.65234 5.84144 9.65234Z"
        fill="#0060FF"
      />
    </svg>
  ),
  horizontalDottedMenuSvg: (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 13C7.9 13 7 13.9 7 15C7 16.1 7.9 17 9 17C10.1 17 11 16.1 11 15C11 13.9 10.1 13 9 13ZM21 13C19.9 13 19 13.9 19 15C19 16.1 19.9 17 21 17C22.1 17 23 16.1 23 15C23 13.9 22.1 13 21 13ZM15 13C13.9 13 13 13.9 13 15C13 16.1 13.9 17 15 17C16.1 17 17 16.1 17 15C17 13.9 16.1 13 15 13Z"
        fill="#C3CAD9"
      />
    </svg>
  ),
  squareMessageText: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.83333 7.08333H10M5.83333 10H12.5M8.06979 15H13.5C14.9001 15 15.6002 15 16.135 14.7275C16.6054 14.4878 16.9878 14.1054 17.2275 13.635C17.5 13.1002 17.5 12.4001 17.5 11V6.5C17.5 5.09987 17.5 4.3998 17.2275 3.86502C16.9878 3.39462 16.6054 3.01217 16.135 2.77248C15.6002 2.5 14.9001 2.5 13.5 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V16.9463C2.5 17.3903 2.5 17.6123 2.59102 17.7263C2.67019 17.8255 2.79022 17.8832 2.91712 17.8831C3.06302 17.8829 3.23639 17.7442 3.58313 17.4668L5.57101 15.8765C5.9771 15.5517 6.18014 15.3892 6.40624 15.2737C6.60683 15.1712 6.82036 15.0963 7.04101 15.051C7.28972 15 7.54975 15 8.06979 15Z"
        stroke="#B3B8DB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  fileAttachment: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.4167 1.66699H12.6667C14.0668 1.66699 14.7669 1.66699 15.3016 1.93948C15.772 2.17916 16.1545 2.56161 16.3942 3.03202C16.6667 3.5668 16.6667 4.26686 16.6667 5.66699V14.3337C16.6667 15.7338 16.6667 16.4339 16.3942 16.9686C16.1545 17.439 15.772 17.8215 15.3016 18.0612C14.7669 18.3337 14.0668 18.3337 12.6667 18.3337H7.33333C5.9332 18.3337 5.23314 18.3337 4.69836 18.0612C4.22795 17.8215 3.8455 17.439 3.60582 16.9686C3.33333 16.4339 3.33333 15.7338 3.33333 14.3337V13.7503M13.3333 10.8337H9.58333M13.3333 7.50033H10.4167M13.3333 14.167H6.66667M5 8.33366V3.75033C5 3.05997 5.55964 2.50033 6.25 2.50033C6.94036 2.50033 7.5 3.05997 7.5 3.75033V8.33366C7.5 9.71437 6.38071 10.8337 5 10.8337C3.61929 10.8337 2.5 9.71437 2.5 8.33366V5.00033"
        stroke="#B3B8DB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  clockIcon: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.0001 7.91699V11.2503L12.0834 12.5003M10.0001 4.16699C6.08806 4.16699 2.91675 7.33831 2.91675 11.2503C2.91675 15.1623 6.08806 18.3337 10.0001 18.3337C13.9121 18.3337 17.0834 15.1623 17.0834 11.2503C17.0834 7.33831 13.9121 4.16699 10.0001 4.16699ZM10.0001 4.16699V1.66699M8.33341 1.66699H11.6667M16.9409 4.66036L15.6909 3.41036L16.3159 4.03536M3.05927 4.66036L4.30927 3.41036L3.68427 4.03536"
        stroke="#B3B8DB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  primaryPlusSvg: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 4.16602V15.8327M4.16669 9.99935H15.8334"
        stroke="#6941C6"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  primaryListIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z"
        stroke="#6941C6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  lightBlueRefreshSvg: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_510_29847)">
        <path
          d="M7 1C7 1 7.42462 1.06066 9.18198 2.81802C10.9393 4.57538 10.9393 7.42462 9.18198 9.18198C8.55934 9.80462 7.79964 10.2067 7 10.3881M7 1L10 1M7 1L7 4M5 10.9999C5 10.9999 4.57538 10.9392 2.81802 9.18188C1.06066 7.42452 1.06066 4.57528 2.81802 2.81792C3.44066 2.19528 4.20036 1.79325 5 1.61182M5 10.9999L2 11M5 10.9999L5 8"
          stroke="#0BA5EC"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_510_29847">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  threeLayersSvg: (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_603_34887)">
        <path
          d="M1.66675 9.99997L9.70194 14.0176C9.81126 14.0722 9.86592 14.0996 9.92325 14.1103C9.97403 14.1198 10.0261 14.1198 10.0769 14.1103C10.1342 14.0996 10.1889 14.0722 10.2982 14.0176L18.3334 9.99997M1.66675 14.1666L9.70194 18.1842C9.81126 18.2389 9.86592 18.2662 9.92325 18.277C9.97403 18.2865 10.0261 18.2865 10.0769 18.277C10.1342 18.2662 10.1889 18.2389 10.2982 18.1842L18.3334 14.1666M1.66675 5.83331L9.70194 1.81571C9.81126 1.76105 9.86592 1.73372 9.92325 1.72297C9.97403 1.71344 10.0261 1.71344 10.0769 1.72297C10.1342 1.73372 10.1889 1.76105 10.2982 1.81571L18.3334 5.83331L10.2982 9.8509C10.1889 9.90556 10.1342 9.93289 10.0769 9.94365C10.0261 9.95317 9.97403 9.95317 9.92325 9.94365C9.86592 9.93289 9.81126 9.90556 9.70194 9.8509L1.66675 5.83331Z"
          stroke="#667085"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_603_34887">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  grayRefreshIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M1.3335 9.33333C1.3335 9.33333 1.41438 9.8995 3.75752 12.2426C6.10067 14.5858 9.89966 14.5858 12.2428 12.2426C13.073 11.4125 13.609 10.3995 13.8509 9.33333M1.3335 9.33333V13.3333M1.3335 9.33333H5.3335M14.6668 6.66667C14.6668 6.66667 14.5859 6.10051 12.2428 3.75736C9.89966 1.41421 6.10067 1.41421 3.75752 3.75736C2.92734 4.58754 2.39129 5.60048 2.14938 6.66667M14.6668 6.66667V2.66667M14.6668 6.66667H10.6668"
        stroke="#C3C8D0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  primaryRefreshIcon: (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9308 8.02122C11.7688 9.54366 10.9061 10.9703 9.47873 11.7944C7.1072 13.1637 4.07473 12.3511 2.70552 9.97957L2.55969 9.72698M2.06849 6.97936C2.23055 5.45692 3.09317 4.03025 4.52058 3.20613C6.89212 1.83693 9.92459 2.64948 11.2938 5.02101L11.4396 5.2736M2.0376 11.0388L2.46463 9.44511L4.05832 9.87214M9.94131 5.12845L11.535 5.55548L11.962 3.96178"
        stroke="#667085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  checkMarkIcon: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.6663 5L7.49967 14.1667L3.33301 10"
        stroke="#7F56D9"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  chevronDown: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="chevron-down">
        <path
          id="Icon"
          d="M5 7.5L10 12.5L15 7.5"
          stroke="#344054"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  pencil2: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="pencil-02" clipPath="url(#clip0_13839_50717)">
        <path
          id="Icon"
          d="M15.0003 1.6665L18.3337 4.99984M1.66699 18.3332L2.73066 14.4331C2.80006 14.1786 2.83475 14.0514 2.88802 13.9327C2.93531 13.8274 2.99343 13.7273 3.06142 13.6339C3.138 13.5288 3.23125 13.4356 3.41775 13.2491L12.0289 4.63791C12.1939 4.4729 12.2764 4.3904 12.3716 4.35949C12.4553 4.3323 12.5454 4.3323 12.6291 4.35949C12.7242 4.3904 12.8067 4.4729 12.9717 4.63791L15.3623 7.02843C15.5273 7.19344 15.6098 7.27594 15.6407 7.37108C15.6679 7.45477 15.6679 7.54491 15.6407 7.62859C15.6098 7.72373 15.5273 7.80624 15.3623 7.97124L6.75108 16.5824C6.56458 16.7689 6.47134 16.8622 6.36623 16.9387C6.2729 17.0067 6.17276 17.0649 6.06742 17.1121C5.94878 17.1654 5.82156 17.2001 5.56711 17.2695L1.66699 18.3332Z"
          stroke="#344054"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_13839_50717">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  featuredIcon: (
    <svg width="48" height="48" viewBox="0 0 52 53" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dii_13021_47902)">
        <path
          d="M2 11.5C2 5.97715 6.47715 1.5 12 1.5H40C45.5229 1.5 50 5.97715 50 11.5V39.5C50 45.0229 45.5228 49.5 40 49.5H12C6.47715 49.5 2 45.0228 2 39.5V11.5Z"
          fill="#F4EBFF"
        />
        <path
          d="M2.5 11.5C2.5 6.25329 6.75329 2 12 2H40C45.2467 2 49.5 6.25329 49.5 11.5V39.5C49.5 44.7467 45.2467 49 40 49H12C6.75329 49 2.5 44.7467 2.5 39.5V11.5Z"
          stroke="#E4E7EC"
        />
        <path
          d="M20 25.5H32M17 19.5H35M23 31.5H29"
          stroke="#344054"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_dii_13021_47902"
          x="0"
          y="0.5"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13021_47902" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_13021_47902"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_13021_47902" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect3_innerShadow_13021_47902"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_13021_47902"
            result="effect3_innerShadow_13021_47902"
          />
        </filter>
      </defs>
    </svg>
  ),
  featuredCheckIcon: (
    <svg width="48" height="48" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 24.5C0 11.2452 10.7452 0.5 24 0.5C37.2548 0.5 48 11.2452 48 24.5C48 37.7548 37.2548 48.5 24 48.5C10.7452 48.5 0 37.7548 0 24.5Z"
        fill="#DCFAE6"
      />
      <path
        d="M19.5 24.5L22.5 27.5L28.5 21.5M34 24.5C34 30.0228 29.5228 34.5 24 34.5C18.4772 34.5 14 30.0228 14 24.5C14 18.9772 18.4772 14.5 24 14.5C29.5228 14.5 34 18.9772 34 24.5Z"
        stroke="#079455"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  roundedPattern: (
    <svg
      width="216"
      height="217"
      viewBox="0 0 216 217"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="48" cy="48.5" r="47.5" stroke="#E4E7EC" />
      <circle cx="48" cy="48.5" r="47.5" stroke="#E4E7EC" strokeOpacity="0.8" />
      <circle cx="48" cy="48.5" r="71.5" stroke="#E4E7EC" strokeOpacity="0.6" />
      <circle cx="48" cy="48.5" r="95.5" stroke="#E4E7EC" strokeOpacity="0.4" />
      <circle cx="48" cy="48.5" r="119.5" stroke="#E4E7EC" strokeOpacity="0.3" />
      <circle cx="48" cy="48.5" r="143.5" stroke="#E4E7EC" strokeOpacity="0.2" />
      <circle cx="48" cy="48.5" r="167.5" stroke="#E4E7EC" strokeOpacity="0.1" />
    </svg>
  ),
  primaryFolderIcon: (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1_40000026_51706" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 3C3.58172 3 0 6.58172 0 11V19.8V19.954V32.2C0 36.6804 0 38.9206 0.871948 40.6319C1.63893 42.1372 2.86278 43.3611 4.36808 44.1281C6.07937 45 8.31958 45 12.8 45H35.2C39.6804 45 41.9206 45 43.6319 44.1281C45.1372 43.3611 46.3611 42.1372 47.1281 40.6319C48 38.9206 48 36.6804 48 32.2V19.8C48 15.3196 48 13.0794 47.1281 11.3681C46.3611 9.86278 45.1372 8.63893 43.6319 7.87195C41.9206 7 39.6804 7 35.2 7H26.5719C22.7981 7 19.2047 3 15.431 3H8Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 3C3.58172 3 0 6.58172 0 11V19.8V19.954V32.2C0 36.6804 0 38.9206 0.871948 40.6319C1.63893 42.1372 2.86278 43.3611 4.36808 44.1281C6.07937 45 8.31958 45 12.8 45H35.2C39.6804 45 41.9206 45 43.6319 44.1281C45.1372 43.3611 46.3611 42.1372 47.1281 40.6319C48 38.9206 48 36.6804 48 32.2V19.8C48 15.3196 48 13.0794 47.1281 11.3681C46.3611 9.86278 45.1372 8.63893 43.6319 7.87195C41.9206 7 39.6804 7 35.2 7H26.5719C22.7981 7 19.2047 3 15.431 3H8Z"
        fill="#6941C6"
      />
      <path
        d="M0.871948 40.6319L1.76295 40.1779H1.76295L0.871948 40.6319ZM4.36808 44.1281L4.82207 43.237L4.36808 44.1281ZM43.6319 44.1281L43.1779 43.237L43.6319 44.1281ZM47.1281 40.6319L46.237 40.1779L47.1281 40.6319ZM47.1281 11.3681L46.237 11.8221V11.8221L47.1281 11.3681ZM43.6319 7.87195L43.1779 8.76295V8.76295L43.6319 7.87195ZM1 11C1 7.13401 4.13401 4 8 4V2C3.02944 2 -1 6.02944 -1 11H1ZM1 19.8V11H-1V19.8H1ZM1 19.954V19.8H-1V19.954H1ZM1 32.2V19.954H-1V32.2H1ZM1.76295 40.1779C1.41078 39.4868 1.20961 38.6451 1.10567 37.373C1.00078 36.0891 1 34.4567 1 32.2H-1C-1 34.4237 -1.00078 36.1516 -0.887685 37.5358C-0.773639 38.9317 -0.538833 40.0658 -0.0190584 41.0859L1.76295 40.1779ZM4.82207 43.237C3.50493 42.5659 2.43407 41.4951 1.76295 40.1779L-0.0190589 41.0859C0.843802 42.7794 2.22063 44.1562 3.91409 45.0191L4.82207 43.237ZM12.8 44C10.5433 44 8.9109 43.9992 7.62705 43.8943C6.35487 43.7904 5.51325 43.5892 4.82207 43.237L3.91409 45.0191C4.9342 45.5388 6.06833 45.7736 7.46418 45.8877C8.84837 46.0008 10.5763 46 12.8 46V44ZM35.2 44H12.8V46H35.2V44ZM43.1779 43.237C42.4868 43.5892 41.6451 43.7904 40.373 43.8943C39.0891 43.9992 37.4567 44 35.2 44V46C37.4237 46 39.1516 46.0008 40.5358 45.8877C41.9317 45.7736 43.0658 45.5388 44.0859 45.0191L43.1779 43.237ZM46.237 40.1779C45.5659 41.4951 44.4951 42.5659 43.1779 43.237L44.0859 45.0191C45.7794 44.1562 47.1562 42.7794 48.0191 41.0859L46.237 40.1779ZM47 32.2C47 34.4567 46.9992 36.0891 46.8943 37.373C46.7904 38.6451 46.5892 39.4868 46.237 40.1779L48.0191 41.0859C48.5388 40.0658 48.7736 38.9317 48.8877 37.5358C49.0008 36.1516 49 34.4237 49 32.2H47ZM47 19.8V32.2H49V19.8H47ZM46.237 11.8221C46.5892 12.5132 46.7904 13.3549 46.8943 14.627C46.9992 15.9109 47 17.5433 47 19.8H49C49 17.5763 49.0008 15.8484 48.8877 14.4642C48.7736 13.0683 48.5388 11.9342 48.0191 10.9141L46.237 11.8221ZM43.1779 8.76295C44.4951 9.43407 45.5659 10.5049 46.237 11.8221L48.0191 10.9141C47.1562 9.22063 45.7794 7.8438 44.0859 6.98094L43.1779 8.76295ZM35.2 8C37.4567 8 39.0891 8.00078 40.373 8.10567C41.6451 8.20961 42.4868 8.41078 43.1779 8.76295L44.0859 6.98094C43.0658 6.46117 41.9317 6.22636 40.5358 6.11231C39.1516 5.99922 37.4237 6 35.2 6V8ZM26.5719 8H35.2V6H26.5719V8ZM8 4H15.431V2H8V4ZM26.5719 6C24.9881 6 23.3815 5.15439 21.4786 4.12118C19.698 3.15439 17.6209 2 15.431 2V4C17.0148 4 18.6213 4.84561 20.5243 5.87882C22.3049 6.84561 24.3819 8 26.5719 8V6Z"
        fill="url(#paint0_linear_40000026_51706)"
        mask="url(#path-1-inside-1_40000026_51706)"
      />
      <rect
        x="0.5"
        y="13.5"
        width="47"
        height="31"
        rx="7.5"
        fill="#7F56D9"
        stroke="url(#paint1_linear_40000026_51706)"
      />
      <rect
        opacity="0.2"
        y="13"
        width="48"
        height="32"
        rx="8"
        fill="url(#paint2_linear_40000026_51706)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_40000026_51706"
          x1="24"
          y1="3"
          x2="24"
          y2="45"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.12" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_40000026_51706"
          x1="24"
          y1="13"
          x2="24"
          y2="45"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.12" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_40000026_51706"
          x1="0"
          y1="13"
          x2="33.0094"
          y2="43.9225"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  pdfFileType: (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 4C4 1.79086 5.79086 0 8 0H24L36 12V36C36 38.2091 34.2091 40 32 40H8C5.79086 40 4 38.2091 4 36V4Z"
        fill="#D92D20"
      />
      <path opacity="0.3" d="M24 0L36 12H28C25.7909 12 24 10.2091 24 8V0Z" fill="white" />
      <path
        d="M11.7491 32V25.4545H14.3315C14.8279 25.4545 15.2508 25.5494 15.6003 25.739C15.9497 25.9265 16.216 26.1875 16.3993 26.522C16.5847 26.8544 16.6773 27.2379 16.6773 27.6726C16.6773 28.1072 16.5836 28.4908 16.3961 28.8232C16.2086 29.1555 15.9369 29.4144 15.5811 29.5998C15.2274 29.7852 14.7991 29.8778 14.2963 29.8778H12.6503V28.7688H14.0726C14.3389 28.7688 14.5584 28.723 14.731 28.6314C14.9057 28.5376 15.0356 28.4087 15.1209 28.2447C15.2082 28.0785 15.2519 27.8878 15.2519 27.6726C15.2519 27.4553 15.2082 27.2656 15.1209 27.1037C15.0356 26.9396 14.9057 26.8129 14.731 26.7234C14.5562 26.6317 14.3347 26.5859 14.0662 26.5859H13.1329V32H11.7491ZM19.8965 32H17.5762V25.4545H19.9157C20.5741 25.4545 21.1408 25.5856 21.616 25.8477C22.0911 26.1076 22.4565 26.4815 22.7122 26.9695C22.97 27.4574 23.0989 28.0412 23.0989 28.7209C23.0989 29.4027 22.97 29.9886 22.7122 30.4787C22.4565 30.9687 22.089 31.3448 21.6096 31.6069C21.1323 31.869 20.5613 32 19.8965 32ZM18.9601 30.8143H19.839C20.2481 30.8143 20.5922 30.7418 20.8713 30.5969C21.1526 30.4499 21.3635 30.223 21.5041 29.9162C21.6469 29.6072 21.7183 29.2088 21.7183 28.7209C21.7183 28.2372 21.6469 27.842 21.5041 27.5352C21.3635 27.2283 21.1536 27.0025 20.8745 26.8576C20.5954 26.7127 20.2513 26.6403 19.8422 26.6403H18.9601V30.8143ZM24.1241 32V25.4545H28.4579V26.5955H25.5079V28.1552H28.1702V29.2962H25.5079V32H24.1241Z"
        fill="white"
      />
    </svg>
  ),
  blackDownArrow: (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 1.33203V6.66536M4 6.66536L6 4.66536M4 6.66536L2 4.66536"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  filtersLine: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 10H15M2.5 5H17.5M7.5 15H12.5"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  fileIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M16 13H8M16 17H8M10 9H8M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  downloadCloudIcon: (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.33329 14.0352C2.3283 13.3625 1.66663 12.2168 1.66663 10.9167C1.66663 8.96369 3.15955 7.35941 5.06641 7.18281C5.45647 4.81011 7.51683 3 9.99996 3C12.4831 3 14.5434 4.81011 14.9335 7.18281C16.8404 7.35941 18.3333 8.96369 18.3333 10.9167C18.3333 12.2168 17.6716 13.3625 16.6666 14.0352M6.66663 14.6667L9.99996 18M9.99996 18L13.3333 14.6667M9.99996 18V10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  pencileSvg: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.75 15.75H9.75002M1.875 16.125L6.03695 14.5242C6.30316 14.4218 6.43626 14.3707 6.56079 14.3038C6.6714 14.2444 6.77685 14.1759 6.87603 14.0989C6.98769 14.0123 7.08853 13.9115 7.29021 13.7098L15.75 5.24998C16.5784 4.42156 16.5784 3.07841 15.75 2.24998C14.9216 1.42156 13.5784 1.42156 12.75 2.24998L4.29021 10.7098C4.08853 10.9115 3.98769 11.0123 3.90104 11.124C3.82408 11.2231 3.75555 11.3286 3.69618 11.4392C3.62933 11.5637 3.57814 11.6968 3.47575 11.963L1.875 16.125ZM1.875 16.125L3.41859 12.1117C3.52905 11.8245 3.58428 11.6809 3.67901 11.6151C3.76179 11.5577 3.86423 11.5359 3.96322 11.5548C4.0765 11.5765 4.18529 11.6853 4.40286 11.9028L6.09718 13.5971C6.31475 13.8147 6.42354 13.9235 6.44517 14.0368C6.46408 14.1358 6.44234 14.2382 6.38486 14.321C6.31908 14.4157 6.17549 14.471 5.8883 14.5814L1.875 16.125Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  trashSvgIcon: (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.3333 4.99935V4.33268C12.3333 3.39926 12.3333 2.93255 12.1517 2.57603C11.9919 2.26243 11.7369 2.00746 11.4233 1.84767C11.0668 1.66602 10.6001 1.66602 9.66667 1.66602H8.33333C7.39991 1.66602 6.9332 1.66602 6.57668 1.84767C6.26308 2.00746 6.00811 2.26243 5.84832 2.57603C5.66667 2.93255 5.66667 3.39926 5.66667 4.33268V4.99935M7.33333 9.58268V13.7493M10.6667 9.58268V13.7493M1.5 4.99935H16.5M14.8333 4.99935V14.3327C14.8333 15.7328 14.8333 16.4329 14.5608 16.9677C14.3212 17.4381 13.9387 17.8205 13.4683 18.0602C12.9335 18.3327 12.2335 18.3327 10.8333 18.3327H7.16667C5.76654 18.3327 5.06647 18.3327 4.53169 18.0602C4.06129 17.8205 3.67883 17.4381 3.43915 16.9677C3.16667 16.4329 3.16667 15.7328 3.16667 14.3327V4.99935"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  folderIcon: (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.13 4.68222L9.2041 2.62839C8.93763 2.03728 8.80438 1.74172 8.6056 1.52579C8.42981 1.33483 8.21795 1.18961 7.98534 1.10063C7.72231 1 7.42437 1 6.8285 1H3.656C2.72631 1 2.26147 1 1.90638 1.20067C1.59403 1.37718 1.34008 1.65884 1.18093 2.00526C1 2.3991 1 2.91466 1 3.94578V4.68222M1 4.68222H13.616C15.0105 4.68222 15.7078 4.68222 16.2404 4.98323C16.709 5.248 17.0899 5.67048 17.3286 6.19012C17.6 6.78087 17.6 7.55421 17.6 9.10089V13.1513C17.6 14.698 17.6 15.4713 17.3286 16.0621C17.0899 16.5817 16.709 17.0042 16.2404 17.269C15.7078 17.57 15.0105 17.57 13.616 17.57H4.984C3.58947 17.57 2.8922 17.57 2.35956 17.269C1.89104 17.0042 1.51012 16.5817 1.27139 16.0621C1 15.4713 1 14.698 1 13.1513V4.68222Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  thumbIcon: (
    <svg width="35" height="36" viewBox="0 0 35 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M27.9984 16.7416C27.9984 15.2716 26.8084 14.5016 25.1984 14.5016H20.5084C20.8584 13.2416 20.9984 12.0516 20.9984 11.0016C20.9984 6.94156 19.8784 6.10156 18.8984 6.10156C18.2684 6.10156 17.7784 6.17156 17.1484 6.52156C16.9384 6.66156 16.8684 6.80156 16.7984 7.01156L16.0984 10.7916C15.3284 12.7516 13.4384 14.5016 11.8984 15.6916V25.7016C12.4584 25.7016 13.0184 25.9816 13.7184 26.3316C14.4884 26.6816 15.2584 27.1016 16.0984 27.1016H22.7484C24.1484 27.1016 25.1984 25.9816 25.1984 25.0016C25.1984 24.7916 25.1984 24.6516 25.1284 24.5116C25.9684 24.1616 26.5984 23.4616 26.5984 22.5516C26.5984 22.1316 26.5284 21.7816 26.3884 21.4316C26.9484 21.0816 27.4384 20.4516 27.4384 19.7516C27.4384 19.3316 27.2284 18.9116 27.0184 18.5616C27.5784 18.1416 27.9984 17.4416 27.9984 16.7416ZM26.5284 16.7416C26.5284 17.6516 25.6184 17.7216 25.4784 18.1416C25.3384 18.6316 26.0384 18.7716 26.0384 19.6116C26.0384 20.4516 24.9884 20.4516 24.8484 20.9416C24.7084 21.5016 25.1984 21.6416 25.1984 22.4816V22.6216C25.0584 23.3216 24.0084 23.3916 23.7984 23.6716C23.5884 24.0216 23.7984 24.1616 23.7984 24.9316C23.7984 25.3516 23.3084 25.6316 22.7484 25.6316H16.0984C15.5384 25.6316 14.9784 25.3516 14.2784 25.0016C13.7184 24.7216 13.1584 24.4416 12.5984 24.3016V16.9516C14.3484 15.6216 16.5884 13.6616 17.4284 11.2116V11.0716L18.0584 7.57156C18.3384 7.50156 18.5484 7.50156 18.8984 7.50156C19.0384 7.50156 19.5984 8.34156 19.5984 11.0016C19.5984 12.0516 19.3884 13.1716 19.0384 14.5016H18.8984C18.4784 14.5016 18.1984 14.7816 18.1984 15.2016C18.1984 15.6216 18.4784 15.9016 18.8984 15.9016H25.1984C25.8984 15.9016 26.5284 16.2516 26.5284 16.7416Z"
        fill="currentColor"
      />
      <path
        d="M11.2016 27.1H7.00156C6.23156 27.1 5.60156 26.47 5.60156 25.7V15.9C5.60156 15.13 6.23156 14.5 7.00156 14.5H11.2016C11.9716 14.5 12.6016 15.13 12.6016 15.9V25.7C12.6016 26.47 11.9716 27.1 11.2016 27.1ZM7.00156 15.9V25.7H11.2016V15.9H7.00156Z"
        fill="currentColor"
      />
    </svg>
  ),
  thumbFilledIcon: (
    <svg width="35" height="36" viewBox="0 0 35 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M27.9984 16.7416C27.9984 15.2716 26.8084 14.5016 25.1984 14.5016H20.5084C20.8584 13.2416 20.9984 12.0516 20.9984 11.0016C20.9984 6.94156 19.8784 6.10156 18.8984 6.10156C18.2684 6.10156 17.7784 6.17156 17.1484 6.52156C16.9384 6.66156 16.8684 6.80156 16.7984 7.01156L16.0984 10.7916C15.3284 12.7516 13.4384 14.5016 11.8984 15.6916V25.7016C12.4584 25.7016 13.0184 25.9816 13.7184 26.3316C14.4884 26.6816 15.2584 27.1016 16.0984 27.1016H22.7484C24.1484 27.1016 25.1984 25.9816 25.1984 25.0016C25.1984 24.7916 25.1984 24.6516 25.1284 24.5116C25.9684 24.1616 26.5984 23.4616 26.5984 22.5516C26.5984 22.1316 26.5284 21.7816 26.3884 21.4316C26.9484 21.0816 27.4384 20.4516 27.4384 19.7516C27.4384 19.3316 27.2284 18.9116 27.0184 18.5616C27.5784 18.1416 27.9984 17.4416 27.9984 16.7416Z"
        fill="currentColor"
      />
      <path
        d="M11.2016 27.1H7.00156C6.23156 27.1 5.60156 26.47 5.60156 25.7V15.9C5.60156 15.13 6.23156 14.5 7.00156 14.5H11.2016C11.9716 14.5 12.6016 15.13 12.6016 15.9V25.7C12.6016 26.47 11.9716 27.1 11.2016 27.1Z"
        fill="currentColor"
      />
    </svg>
  ),
  downThumbIcon: (
    <svg width="35" height="36" viewBox="0 0 35 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.00156 19.2584C7.00156 20.7284 8.19156 21.4984 9.80156 21.4984H14.4916C14.1416 22.7584 14.0016 23.9484 14.0016 24.9984C14.0016 29.0584 15.1216 29.8984 16.1016 29.8984C16.7316 29.8984 17.2216 29.8284 17.8516 29.4784C18.0616 29.3384 18.1316 29.1984 18.2016 28.9884L18.9016 25.2084C19.6716 23.2484 21.5616 21.4984 23.1016 20.3084V10.2984C22.5416 10.2984 21.9816 10.0184 21.2816 9.66844C20.5116 9.31844 19.7416 8.89844 18.9016 8.89844H12.2516C10.8516 8.89844 9.80156 10.0184 9.80156 10.9984C9.80156 11.2084 9.80156 11.3484 9.87156 11.4884C9.03156 11.8384 8.40156 12.5384 8.40156 13.4484C8.40156 13.8684 8.47156 14.2184 8.61156 14.5684C8.05156 14.9184 7.56156 15.5484 7.56156 16.2484C7.56156 16.6684 7.77156 17.0884 7.98156 17.4384C7.42156 17.8584 7.00156 18.5584 7.00156 19.2584ZM8.47156 19.2584C8.47156 18.3484 9.38156 18.2784 9.52156 17.8584C9.66156 17.3684 8.96156 17.2284 8.96156 16.3884C8.96156 15.5484 10.0116 15.5484 10.1516 15.0584C10.2916 14.4984 9.80156 14.3584 9.80156 13.5184V13.3784C9.94156 12.6784 10.9916 12.6084 11.2016 12.3284C11.4116 11.9784 11.2016 11.8384 11.2016 11.0684C11.2016 10.6484 11.6916 10.3684 12.2516 10.3684H18.9016C19.4616 10.3684 20.0216 10.6484 20.7216 10.9984C21.2816 11.2784 21.8416 11.5584 22.4016 11.6984V19.0484C20.6516 20.3784 18.4116 22.3384 17.5716 24.7884V24.9284L16.9416 28.4284C16.6616 28.4984 16.4516 28.4984 16.1016 28.4984C15.9616 28.4984 15.4016 27.6584 15.4016 24.9984C15.4016 23.9484 15.6116 22.8284 15.9616 21.4984H16.1016C16.5216 21.4984 16.8016 21.2184 16.8016 20.7984C16.8016 20.3784 16.5216 20.0984 16.1016 20.0984H9.80156C9.10156 20.0984 8.47156 19.7484 8.47156 19.2584Z"
        fill="currentColor"
      />
      <path
        d="M23.7984 8.9H27.9984C28.7684 8.9 29.3984 9.53 29.3984 10.3V20.1C29.3984 20.87 28.7684 21.5 27.9984 21.5H23.7984C23.0284 21.5 22.3984 20.87 22.3984 20.1V10.3C22.3984 9.53 23.0284 8.9 23.7984 8.9ZM27.9984 20.1V10.3H23.7984V20.1H27.9984Z"
        fill="currentColor"
      />
    </svg>
  ),
  downThumbFilledIcon: (
    <svg width="35" height="36" viewBox="0 0 35 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.00156 19.2584C7.00156 20.7284 8.19156 21.4984 9.80156 21.4984H14.4916C14.1416 22.7584 14.0016 23.9484 14.0016 24.9984C14.0016 29.0584 15.1216 29.8984 16.1016 29.8984C16.7316 29.8984 17.2216 29.8284 17.8516 29.4784C18.0616 29.3384 18.1316 29.1984 18.2016 28.9884L18.9016 25.2084C19.6716 23.2484 21.5616 21.4984 23.1016 20.3084V10.2984C22.5416 10.2984 21.9816 10.0184 21.2816 9.66844C20.5116 9.31844 19.7416 8.89844 18.9016 8.89844H12.2516C10.8516 8.89844 9.80156 10.0184 9.80156 10.9984C9.80156 11.2084 9.80156 11.3484 9.87156 11.4884C9.03156 11.8384 8.40156 12.5384 8.40156 13.4484C8.40156 13.8684 8.47156 14.2184 8.61156 14.5684C8.05156 14.9184 7.56156 15.5484 7.56156 16.2484C7.56156 16.6684 7.77156 17.0884 7.98156 17.4384C7.42156 17.8584 7.00156 18.5584 7.00156 19.2584Z"
        fill="currentColor"
      />
      <path
        d="M23.7984 8.9H27.9984C28.7684 8.9 29.3984 9.53 29.3984 10.3V20.1C29.3984 20.87 28.7684 21.5 27.9984 21.5H23.7984C23.0284 21.5 22.3984 20.87 22.3984 20.1V10.3C22.3984 9.53 23.0284 8.9 23.7984 8.9Z"
        fill="currentColor"
      />
    </svg>
  ),
  locationIcon: (
    <svg width="11" height="15" viewBox="0 0 11 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_711_90428)">
        <path
          d="M5.89805 13.8023C7.30078 12.0469 10.5 7.79219 10.5 5.40234C10.5 2.50391 8.14844 0.152344 5.25 0.152344C2.35156 0.152344 0 2.50391 0 5.40234C0 7.79219 3.19922 12.0469 4.60195 13.8023C4.93828 14.2207 5.56172 14.2207 5.89805 13.8023ZM5.25 3.65234C5.71413 3.65234 6.15925 3.83672 6.48744 4.16491C6.81563 4.4931 7 4.93821 7 5.40234C7 5.86647 6.81563 6.31159 6.48744 6.63978C6.15925 6.96797 5.71413 7.15234 5.25 7.15234C4.78587 7.15234 4.34075 6.96797 4.01256 6.63978C3.68437 6.31159 3.5 5.86647 3.5 5.40234C3.5 4.93821 3.68437 4.4931 4.01256 4.16491C4.34075 3.83672 4.78587 3.65234 5.25 3.65234Z"
          fill="#6B7280"
        />
      </g>
      <defs>
        <clipPath id="clip0_711_90428">
          <path d="M0 0.152344H10.5V14.1523H0V0.152344Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  PrimarylocationIcon: (
    <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.30312 15.6C8.90625 13.5938 12.5625 8.73125 12.5625 6C12.5625 2.6875 9.875 0 6.5625 0C3.25 0 0.5625 2.6875 0.5625 6C0.5625 8.73125 4.21875 13.5938 5.82188 15.6C6.20625 16.0781 6.91875 16.0781 7.30312 15.6ZM6.5625 4C7.09293 4 7.60164 4.21071 7.97671 4.58579C8.35179 4.96086 8.5625 5.46957 8.5625 6C8.5625 6.53043 8.35179 7.03914 7.97671 7.41421C7.60164 7.78929 7.09293 8 6.5625 8C6.03207 8 5.52336 7.78929 5.14829 7.41421C4.77321 7.03914 4.5625 6.53043 4.5625 6C4.5625 5.46957 4.77321 4.96086 5.14829 4.58579C5.52336 4.21071 6.03207 4 6.5625 4Z"
        fill="#6D28D9"
      />
    </svg>
  ),
  starIcon: (
    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_711_90432)">
        <path
          d="M9.24725 0.644531C9.10232 0.34375 8.79607 0.152344 8.45975 0.152344C8.12342 0.152344 7.8199 0.34375 7.67225 0.644531L5.91404 4.26211L1.98748 4.8418C1.65936 4.89102 1.38592 5.1207 1.28475 5.43516C1.18357 5.74961 1.26561 6.09687 1.50076 6.3293L4.34998 9.14844L3.67732 13.1324C3.62264 13.4605 3.75936 13.7941 4.03006 13.9883C4.30076 14.1824 4.65897 14.207 4.95428 14.0512L8.46248 12.1781L11.9707 14.0512C12.266 14.207 12.6242 14.1852 12.8949 13.9883C13.1656 13.7914 13.3023 13.4605 13.2476 13.1324L12.5722 9.14844L15.4215 6.3293C15.6566 6.09687 15.7414 5.74961 15.6375 5.43516C15.5336 5.1207 15.2629 4.89102 14.9347 4.8418L11.0055 4.26211L9.24725 0.644531Z"
          fill="#6B7280"
        />
      </g>
      <defs>
        <clipPath id="clip0_711_90432">
          <path d="M0.578125 0.152344H16.3281V14.1523H0.578125V0.152344Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  AIstarIcon: (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.5 21V16M3.5 6V1M1 3.5H6M1 18.5H6M12 2L10.2658 6.50886C9.98381 7.24209 9.84281 7.60871 9.62353 7.91709C9.42919 8.1904 9.1904 8.42919 8.91709 8.62353C8.60871 8.8428 8.24209 8.98381 7.50886 9.26582L3 11L7.50886 12.7342C8.24209 13.0162 8.60871 13.1572 8.91709 13.3765C9.1904 13.5708 9.42919 13.8096 9.62353 14.0829C9.84281 14.3913 9.98381 14.7579 10.2658 15.4911L12 20L13.7342 15.4911C14.0162 14.7579 14.1572 14.3913 14.3765 14.0829C14.5708 13.8096 14.8096 13.5708 15.0829 13.3765C15.3913 13.1572 15.7579 13.0162 16.4911 12.7342L21 11L16.4911 9.26582C15.7579 8.98381 15.3913 8.8428 15.0829 8.62353C14.8096 8.42919 14.5708 8.1904 14.3765 7.91709C14.1572 7.60871 14.0162 7.24209 13.7342 6.50886L12 2Z"
        stroke="#9E77ED"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  TargetIcon: (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5 10.5C17.5 9.51509 17.306 8.53982 16.9291 7.62987C16.5522 6.71993 15.9997 5.89314 15.3033 5.1967C14.6069 4.50026 13.7801 3.94781 12.8701 3.5709C11.9602 3.19399 10.9849 3 10 3C9.01509 3 8.03982 3.19399 7.12987 3.5709C6.21993 3.94781 5.39314 4.50026 4.6967 5.1967C4.00026 5.89314 3.44781 6.71993 3.0709 7.62987C2.69399 8.53982 2.5 9.51509 2.5 10.5C2.5 11.4849 2.69399 12.4602 3.0709 13.3701C3.44781 14.2801 4.00026 15.1069 4.6967 15.8033C5.39314 16.4997 6.21993 17.0522 7.12987 17.4291C8.03982 17.806 9.01509 18 10 18C10.9849 18 11.9602 17.806 12.8701 17.4291C13.7801 17.0522 14.6069 16.4997 15.3033 15.8033C15.9997 15.1069 16.5522 14.2801 16.9291 13.3701C17.306 12.4602 17.5 11.4849 17.5 10.5ZM0 10.5C0 7.84784 1.05357 5.3043 2.92893 3.42893C4.8043 1.55357 7.34784 0.5 10 0.5C12.6522 0.5 15.1957 1.55357 17.0711 3.42893C18.9464 5.3043 20 7.84784 20 10.5C20 13.1522 18.9464 15.6957 17.0711 17.5711C15.1957 19.4464 12.6522 20.5 10 20.5C7.34784 20.5 4.8043 19.4464 2.92893 17.5711C1.05357 15.6957 0 13.1522 0 10.5ZM10 13.625C10.8288 13.625 11.6237 13.2958 12.2097 12.7097C12.7958 12.1237 13.125 11.3288 13.125 10.5C13.125 9.6712 12.7958 8.87634 12.2097 8.29029C11.6237 7.70424 10.8288 7.375 10 7.375C9.1712 7.375 8.37634 7.70424 7.79029 8.29029C7.20424 8.87634 6.875 9.6712 6.875 10.5C6.875 11.3288 7.20424 12.1237 7.79029 12.7097C8.37634 13.2958 9.1712 13.625 10 13.625ZM10 4.875C11.4918 4.875 12.9226 5.46763 13.9775 6.52252C15.0324 7.57742 15.625 9.00816 15.625 10.5C15.625 11.9918 15.0324 13.4226 13.9775 14.4775C12.9226 15.5324 11.4918 16.125 10 16.125C8.50816 16.125 7.07742 15.5324 6.02252 14.4775C4.96763 13.4226 4.375 11.9918 4.375 10.5C4.375 9.00816 4.96763 7.57742 6.02252 6.52252C7.07742 5.46763 8.50816 4.875 10 4.875ZM8.75 10.5C8.75 10.1685 8.8817 9.85054 9.11612 9.61612C9.35054 9.3817 9.66848 9.25 10 9.25C10.3315 9.25 10.6495 9.3817 10.8839 9.61612C11.1183 9.85054 11.25 10.1685 11.25 10.5C11.25 10.8315 11.1183 11.1495 10.8839 11.3839C10.6495 11.6183 10.3315 11.75 10 11.75C9.66848 11.75 9.35054 11.6183 9.11612 11.3839C8.8817 11.1495 8.75 10.8315 8.75 10.5Z"
        fill="#6366F1"
      />
    </svg>
  ),
  PlusIcon: (
    <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_787_17458)">
        <path d="M14 16H0V0H14V16Z" stroke="#E5E7EB" />
        <path
          d="M8 2.5C8 1.94687 7.55312 1.5 7 1.5C6.44688 1.5 6 1.94687 6 2.5V7H1.5C0.946875 7 0.5 7.44688 0.5 8C0.5 8.55312 0.946875 9 1.5 9H6V13.5C6 14.0531 6.44688 14.5 7 14.5C7.55312 14.5 8 14.0531 8 13.5V9H12.5C13.0531 9 13.5 8.55312 13.5 8C13.5 7.44688 13.0531 7 12.5 7H8V2.5Z"
          fill="#6D28D9"
        />
      </g>
      <defs>
        <clipPath id="clip0_787_17458">
          <rect width="14" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  CheckIcon: (
    <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.7086 0.292969C14.0992 0.683594 14.0992 1.31797 13.7086 1.70859L5.70859 9.70859C5.31797 10.0992 4.68359 10.0992 4.29297 9.70859L0.292969 5.70859C-0.0976562 5.31797 -0.0976562 4.68359 0.292969 4.29297C0.683594 3.90234 1.31797 3.90234 1.70859 4.29297L5.00234 7.58359L12.2961 0.292969C12.6867 -0.0976562 13.3211 -0.0976562 13.7117 0.292969H13.7086Z"
        fill="#16A34A"
      />
    </svg>
  ),
  MoreHorizontalIcon: (
    <svg width="14" height="5" viewBox="0 0 14 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.25 2.5C0.25 2.03587 0.434374 1.59075 0.762563 1.26256C1.09075 0.934375 1.53587 0.75 2 0.75C2.46413 0.75 2.90925 0.934375 3.23744 1.26256C3.56563 1.59075 3.75 2.03587 3.75 2.5C3.75 2.96413 3.56563 3.40925 3.23744 3.73744C2.90925 4.06563 2.46413 4.25 2 4.25C1.53587 4.25 1.09075 4.06563 0.762563 3.73744C0.434374 3.40925 0.25 2.96413 0.25 2.5ZM5.25 2.5C5.25 2.03587 5.43437 1.59075 5.76256 1.26256C6.09075 0.934375 6.53587 0.75 7 0.75C7.46413 0.75 7.90925 0.934375 8.23744 1.26256C8.56563 1.59075 8.75 2.03587 8.75 2.5C8.75 2.96413 8.56563 3.40925 8.23744 3.73744C7.90925 4.06563 7.46413 4.25 7 4.25C6.53587 4.25 6.09075 4.06563 5.76256 3.73744C5.43437 3.40925 5.25 2.96413 5.25 2.5ZM12 0.75C12.4641 0.75 12.9092 0.934375 13.2374 1.26256C13.5656 1.59075 13.75 2.03587 13.75 2.5C13.75 2.96413 13.5656 3.40925 13.2374 3.73744C12.9092 4.06563 12.4641 4.25 12 4.25C11.5359 4.25 11.0908 4.06563 10.7626 3.73744C10.4344 3.40925 10.25 2.96413 10.25 2.5C10.25 2.03587 10.4344 1.59075 10.7626 1.26256C11.0908 0.934375 11.5359 0.75 12 0.75Z"
        fill="#ADB5BD"
      />
    </svg>
  ),
  ChatSendIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.50733 4.22867L18.0673 8.50867C21.9073 10.4287 21.9073 13.5687 18.0673 15.4887L9.50733 19.7687C3.74733 22.6487 1.39733 20.2887 4.27733 14.5387L5.14733 12.8087C5.36733 12.3687 5.36733 11.6387 5.14733 11.1987L4.27733 9.45867C1.39733 3.70867 3.75733 1.34867 9.50733 4.22867Z"
        stroke="#7F56D9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.4375 12H10.8375"
        stroke="#7F56D9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  MessageIcon: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.00406 15.678C4.8974 15.678 4.79073 15.658 4.69073 15.618C4.59073 15.578 4.50406 15.518 4.42406 15.4446C4.35073 15.3713 4.29073 15.2846 4.24406 15.1846C4.20406 15.0846 4.18406 14.9846 4.18406 14.878L4.16406 13.2446C3.92406 13.2113 3.68406 13.158 3.4574 13.078C3.22406 12.998 3.00406 12.9046 2.79073 12.7913C2.57073 12.6713 2.37073 12.538 2.18406 12.3846C1.99073 12.238 1.8174 12.0713 1.6574 11.8846C1.4974 11.7046 1.3574 11.5113 1.23073 11.3046C1.11073 11.098 1.00406 10.8846 0.917396 10.658C0.830729 10.4313 0.770729 10.198 0.724063 9.96463C0.684063 9.7313 0.664062 9.4913 0.664062 9.2513V4.91797C0.664062 4.65797 0.684063 4.39797 0.737396 4.13797C0.790729 3.87797 0.870729 3.6313 0.970729 3.38464C1.07073 3.14464 1.1974 2.9113 1.35073 2.6913C1.4974 2.47797 1.66406 2.2713 1.85073 2.08464C2.04406 1.90464 2.25073 1.73797 2.47073 1.5913C2.69073 1.44464 2.93073 1.31797 3.1774 1.21797C3.42406 1.11797 3.6774 1.04464 3.9374 0.991302C4.20406 0.937969 4.46406 0.917969 4.7374 0.917969H7.56406C7.66406 0.917969 7.75073 0.931302 7.84406 0.971302C7.93073 1.00464 8.01073 1.05797 8.0774 1.12464C8.14406 1.1913 8.1974 1.26464 8.23073 1.3513C8.27073 1.43797 8.28406 1.5313 8.28406 1.62464C8.28406 1.71797 8.27073 1.80464 8.23073 1.8913C8.1974 1.97797 8.14406 2.05797 8.0774 2.12464C8.01073 2.1913 7.93073 2.24464 7.84406 2.27797C7.75073 2.3113 7.66406 2.3313 7.56406 2.3313H4.7374C4.56406 2.3313 4.39073 2.3513 4.22406 2.38464C4.05073 2.4113 3.88406 2.46464 3.73073 2.5313C3.57073 2.5913 3.4174 2.6713 3.27073 2.76464C3.13073 2.86464 2.9974 2.9713 2.87073 3.0913C2.75073 3.2113 2.64406 3.33797 2.54406 3.47797C2.45073 3.62464 2.37073 3.7713 2.30406 3.9313C2.2374 4.08464 2.18406 4.24464 2.15073 4.4113C2.1174 4.57797 2.10406 4.74464 2.10406 4.91797V9.2513C2.10406 9.42463 2.1174 9.5913 2.15073 9.76463C2.19073 9.9313 2.2374 10.098 2.30406 10.258C2.37073 10.4113 2.4574 10.5646 2.55073 10.7113C2.65073 10.8513 2.76406 10.9846 2.88406 11.1046C3.01073 11.2313 3.14406 11.338 3.29073 11.4313C3.4374 11.5313 3.59073 11.6113 3.75073 11.678C3.91073 11.7446 4.08406 11.7913 4.25073 11.8246C4.42406 11.858 4.5974 11.878 4.7774 11.878C4.88406 11.878 4.99073 11.898 5.09073 11.938C5.19073 11.978 5.2774 12.038 5.3574 12.1113C5.43073 12.1846 5.49073 12.2713 5.5374 12.3713C5.5774 12.4713 5.5974 12.5713 5.60406 12.678L5.61073 13.6846L7.43073 12.3713C7.8974 12.0446 8.41073 11.878 8.98406 11.878H11.2441C11.4174 11.878 11.5841 11.858 11.7574 11.8246C11.9241 11.7913 12.0907 11.7446 12.2507 11.678C12.4107 11.6113 12.5641 11.5313 12.7041 11.438C12.8507 11.3446 12.9841 11.238 13.1041 11.118C13.2241 10.998 13.3374 10.8646 13.4307 10.7246C13.5241 10.5846 13.6107 10.438 13.6774 10.278C13.7374 10.1246 13.7907 9.95797 13.8241 9.7913C13.8574 9.62463 13.8774 9.45797 13.8774 9.2913V7.0513C13.8774 6.95797 13.8907 6.86463 13.9307 6.77797C13.9641 6.6913 14.0174 6.61797 14.0841 6.5513C14.1507 6.48463 14.2307 6.4313 14.3174 6.39797C14.4107 6.35797 14.4974 6.34464 14.5974 6.34464C14.6907 6.34464 14.7841 6.35797 14.8707 6.39797C14.9574 6.4313 15.0374 6.48463 15.1041 6.5513C15.1707 6.61797 15.2241 6.6913 15.2641 6.77797C15.2974 6.86463 15.3174 6.95797 15.3174 7.0513V9.2913C15.3174 9.5513 15.2907 9.8113 15.2374 10.0713C15.1841 10.3313 15.1107 10.578 15.0041 10.8246C14.9041 11.0646 14.7774 11.298 14.6307 11.5113C14.4841 11.7313 14.3107 11.9313 14.1241 12.118C13.9307 12.3046 13.7307 12.4713 13.5041 12.618C13.2841 12.7646 13.0507 12.8846 12.8041 12.9846C12.5507 13.0846 12.2974 13.1646 12.0374 13.218C11.7774 13.2646 11.5107 13.2913 11.2441 13.2913H9.4574C8.88406 13.2913 8.37073 13.458 7.90406 13.7913L5.49073 15.5246C5.34406 15.6246 5.18406 15.678 5.00406 15.678Z"
        fill="white"
      />
      <path
        d="M14.509 2.26172H10.5519C10.1608 2.26172 9.84375 2.57878 9.84375 2.96989C9.84375 3.361 10.1608 3.67805 10.5519 3.67805H14.509C14.9001 3.67805 15.2171 3.361 15.2171 2.96989C15.2171 2.57878 14.9001 2.26172 14.509 2.26172Z"
        fill="white"
      />
      <path
        d="M13.2541 1.05283C13.2541 0.654743 12.9314 0.332031 12.5333 0.332031C12.1352 0.332031 11.8125 0.654743 11.8125 1.05283V4.89046C11.8125 5.28855 12.1352 5.61126 12.5333 5.61126C12.9314 5.61126 13.2541 5.28855 13.2541 4.89046V1.05283Z"
        fill="white"
      />
    </svg>
  ),
  ChatCloseIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9219 22C17.4219 22 21.9219 17.5 21.9219 12C21.9219 6.5 17.4219 2 11.9219 2C6.42188 2 1.92188 6.5 1.92188 12C1.92187 17.5 6.42188 22 11.9219 22Z"
        stroke="#E9D7FE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.92188 12H15.9219"
        stroke="#E9D7FE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  ChatExpandIcon: (
    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.694 0.25C6.856 0.25 5.4 0.25 4.261 0.403C3.089 0.561 2.14 0.893 1.391 1.641C0.643 2.39 0.311 3.339 0.153 4.511C0 5.651 0 7.106 0 8.944V11.056C0 12.894 0 14.35 0.153 15.489C0.311 16.661 0.643 17.61 1.391 18.359C2.14 19.107 3.089 19.439 4.261 19.597C5.401 19.75 6.856 19.75 8.694 19.75H13.716L13.788 19.749C15.172 19.745 16.311 19.722 17.239 19.597C18.411 19.439 19.36 19.107 20.109 18.359C20.857 17.61 21.189 16.661 21.347 15.489C21.5 14.349 21.5 12.894 21.5 11.056V8.944C21.5 7.106 21.5 5.65 21.347 4.511C21.189 3.339 20.857 2.39 20.109 1.641C19.36 0.893 18.411 0.561 17.239 0.403C16.311 0.278 15.172 0.255 13.789 0.251H13.716L12.806 0.25H8.694ZM13 1.75H8.75C6.843 1.75 5.489 1.752 4.46 1.89C3.455 2.025 2.875 2.279 2.452 2.702C2.029 3.125 1.775 3.705 1.64 4.71C1.502 5.739 1.5 7.093 1.5 9V11C1.5 12.907 1.502 14.262 1.64 15.29C1.775 16.295 2.029 16.875 2.452 17.298C2.875 17.721 3.455 17.975 4.461 18.11C5.489 18.248 6.843 18.25 8.75 18.25H13V1.75ZM14.5 18.244C15.534 18.234 16.358 18.202 17.04 18.11C18.045 17.975 18.625 17.721 19.048 17.298C19.471 16.875 19.725 16.295 19.86 15.289C19.998 14.262 20 12.907 20 11V9C20 7.093 19.998 5.739 19.86 4.71C19.725 3.705 19.471 3.125 19.048 2.702C18.625 2.279 18.045 2.025 17.039 1.89C16.359 1.798 15.534 1.767 14.5 1.756V18.244Z"
        fill="#E9D7FE"
      />
    </svg>
  ),
  UserSearchIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="24" viewBox="0 0 21 24" fill="none">
      <g clipPath="url(#clip0_670_113334)">
        <path
          d="M10.5 12C8.9087 12 7.38258 11.3679 6.25736 10.2426C5.13214 9.11742 4.5 7.5913 4.5 6C4.5 4.4087 5.13214 2.88258 6.25736 1.75736C7.38258 0.632141 8.9087 0 10.5 0C12.0913 0 13.6174 0.632141 14.7426 1.75736C15.8679 2.88258 16.5 4.4087 16.5 6C16.5 7.5913 15.8679 9.11742 14.7426 10.2426C13.6174 11.3679 12.0913 12 10.5 12ZM9.80156 16.8375L8.92969 15.3844C8.62969 14.8828 8.99062 14.25 9.57187 14.25H10.5H11.4234C12.0047 14.25 12.3656 14.8875 12.0656 15.3844L11.1938 16.8375L12.7594 22.6453L14.4469 15.7594C14.5406 15.3797 14.9062 15.1312 15.2859 15.2297C18.5719 16.0547 21 19.0266 21 22.5609C21 23.3578 20.3531 24 19.5609 24H13.3828C13.2844 24 13.1953 23.9812 13.1109 23.9484L13.125 24H7.875L7.88906 23.9484C7.80469 23.9812 7.71094 24 7.61719 24H1.43906C0.646875 24 0 23.3531 0 22.5609C0 19.0219 2.43281 16.05 5.71406 15.2297C6.09375 15.1359 6.45938 15.3844 6.55313 15.7594L8.24063 22.6453L9.80625 16.8375H9.80156Z"
          fill="#7C3AED"
        />
      </g>
      <defs>
        <clipPath id="clip0_670_113334">
          <path d="M0 0H21V24H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  UsersGroupIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 30 24" fill="none">
      <g clipPath="url(#clip0_670_113347)">
        <path
          d="M3.7507 2.25C3.7507 1.65326 3.98776 1.08097 4.40971 0.65901C4.83167 0.237053 5.40397 0 6.0007 0C6.59744 0 7.16974 0.237053 7.59169 0.65901C8.01365 1.08097 8.2507 1.65326 8.2507 2.25C8.2507 2.84674 8.01365 3.41903 7.59169 3.84099C7.16974 4.26295 6.59744 4.5 6.0007 4.5C5.40397 4.5 4.83167 4.26295 4.40971 3.84099C3.98776 3.41903 3.7507 2.84674 3.7507 2.25ZM6.7507 11.3297V14.3812L9.14133 16.7719C9.47414 17.1047 9.69445 17.5312 9.76945 17.9953L10.482 22.2562C10.6179 23.0719 10.0648 23.8453 9.24914 23.9813C8.43351 24.1172 7.66008 23.5641 7.52414 22.7484L6.85383 18.7219L3.13195 15C2.56945 14.4375 2.2507 13.6734 2.2507 12.8766V8.74688C2.2507 7.22813 3.47883 6 4.99758 6C6.12726 6 7.17726 6.5625 7.80539 7.5L10.0273 10.8328L10.5007 11.0672V7.5C10.5007 6.67031 11.171 6 12.0007 6H18.0007C18.8304 6 19.5007 6.67031 19.5007 7.5V11.0719L19.9741 10.8375L22.196 7.5C22.8195 6.5625 23.8741 6 25.0038 6C26.5226 6 27.7507 7.22813 27.7507 8.74688V12.8766C27.7507 13.6734 27.4366 14.4375 26.8741 15L23.1523 18.7219L22.482 22.7484C22.346 23.5641 21.5726 24.1172 20.757 23.9813C19.9413 23.8453 19.3882 23.0719 19.5241 22.2562L20.2366 17.9953C20.3116 17.5312 20.532 17.1047 20.8648 16.7719L23.2554 14.3812V11.3297L22.3648 12.6656C22.1491 12.9938 21.8491 13.2563 21.4976 13.4297L18.7038 14.8266C18.5913 14.8875 18.4741 14.9297 18.3476 14.9578C18.2257 14.9859 18.0991 15 17.9773 14.9953H12.0335C11.9163 15 11.7991 14.9859 11.682 14.9625C11.546 14.9344 11.4195 14.8875 11.3023 14.8219L8.5132 13.425C8.16164 13.2516 7.86633 12.9844 7.64602 12.6609L6.75539 11.325L6.7507 11.3297ZM0.108515 21.9422L2.34914 16.3406L4.65539 18.6469L2.89289 23.0531C2.58351 23.8219 1.71164 24.1969 0.94289 23.8875C0.17414 23.5781 -0.20086 22.7109 0.108515 21.9422ZM24.0007 0C24.5974 0 25.1697 0.237053 25.5917 0.65901C26.0136 1.08097 26.2507 1.65326 26.2507 2.25C26.2507 2.84674 26.0136 3.41903 25.5917 3.84099C25.1697 4.26295 24.5974 4.5 24.0007 4.5C23.404 4.5 22.8317 4.26295 22.4097 3.84099C21.9878 3.41903 21.7507 2.84674 21.7507 2.25C21.7507 1.65326 21.9878 1.08097 22.4097 0.65901C22.8317 0.237053 23.404 0 24.0007 0ZM27.6523 16.3406L29.8929 21.9422C30.2023 22.7109 29.8273 23.5828 29.0585 23.8922C28.2898 24.2016 27.4179 23.8266 27.1085 23.0578L25.346 18.6516L27.6523 16.3453V16.3406Z"
          fill="#7C3AED"
        />
      </g>
      <defs>
        <clipPath id="clip0_670_113347">
          <path d="M0 0H30V24H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  BriefcaseIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="24" viewBox="0 0 21 24" fill="none">
      <g clipPath="url(#clip0_670_113334)">
        <path
          d="M10.5 12C8.9087 12 7.38258 11.3679 6.25736 10.2426C5.13214 9.11742 4.5 7.5913 4.5 6C4.5 4.4087 5.13214 2.88258 6.25736 1.75736C7.38258 0.632141 8.9087 0 10.5 0C12.0913 0 13.6174 0.632141 14.7426 1.75736C15.8679 2.88258 16.5 4.4087 16.5 6C16.5 7.5913 15.8679 9.11742 14.7426 10.2426C13.6174 11.3679 12.0913 12 10.5 12ZM9.80156 16.8375L8.92969 15.3844C8.62969 14.8828 8.99062 14.25 9.57187 14.25H10.5H11.4234C12.0047 14.25 12.3656 14.8875 12.0656 15.3844L11.1938 16.8375L12.7594 22.6453L14.4469 15.7594C14.5406 15.3797 14.9062 15.1312 15.2859 15.2297C18.5719 16.0547 21 19.0266 21 22.5609C21 23.3578 20.3531 24 19.5609 24H13.3828C13.2844 24 13.1953 23.9812 13.1109 23.9484L13.125 24H7.875L7.88906 23.9484C7.80469 23.9812 7.71094 24 7.61719 24H1.43906C0.646875 24 0 23.3531 0 22.5609C0 19.0219 2.43281 16.05 5.71406 15.2297C6.09375 15.1359 6.45938 15.3844 6.55313 15.7594L8.24063 22.6453L9.80625 16.8375H9.80156Z"
          fill="#7C3AED"
        />
      </g>
      <defs>
        <clipPath id="clip0_670_113334">
          <path d="M0 0H21V24H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  RetainedSearchIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="24" viewBox="0 0 27 24" fill="none">
      <g clipPath="url(#clip0_670_113360)">
        <path
          d="M3 0C1.34531 0 0 1.34531 0 3V21C0 22.6547 1.34531 24 3 24H15C16.6547 24 18 22.6547 18 21V20.0953C17.8734 20.1469 17.7469 20.1891 17.6156 20.2219L14.7984 20.925C14.6578 20.9578 14.5172 20.9812 14.3766 20.9906C14.3344 20.9953 14.2922 21 14.25 21H11.25C10.9641 21 10.7063 20.8406 10.5797 20.5875L10.1672 19.7578C10.0875 19.5984 9.92813 19.5 9.75469 19.5C9.58125 19.5 9.41719 19.5984 9.34219 19.7578L8.92969 20.5875C8.79375 20.8641 8.49844 21.0281 8.19375 21C7.88906 20.9719 7.62656 20.7609 7.54219 20.4703L6.75 17.8594L6.29062 19.3969C6.00469 20.3484 5.12812 21 4.13437 21H3.75C3.3375 21 3 20.6625 3 20.25C3 19.8375 3.3375 19.5 3.75 19.5H4.13437C4.46719 19.5 4.75781 19.2844 4.85156 18.9656L5.55 16.6453C5.70937 16.1156 6.19688 15.75 6.75 15.75C7.30312 15.75 7.79063 16.1156 7.95 16.6453L8.49375 18.4547C8.84062 18.1641 9.28125 18 9.75 18C10.4953 18 11.175 18.4219 11.5078 19.0875L11.7141 19.5H12.1312C11.9859 19.0875 11.9578 18.6375 12.0656 18.1969L12.7687 15.3797C12.9 14.85 13.1719 14.3719 13.5563 13.9875L18 9.54375V7.5H12C11.1703 7.5 10.5 6.82969 10.5 6V0H3ZM12 0V6H18L12 0ZM25.7719 6.54844C25.0406 5.81719 23.8547 5.81719 23.1188 6.54844L21.7406 7.92656L25.0687 11.2547L26.4469 9.87656C27.1781 9.14531 27.1781 7.95938 26.4469 7.22344L25.7719 6.54844ZM14.6203 15.0469C14.4281 15.2391 14.2922 15.4781 14.2266 15.7453L13.5234 18.5625C13.4578 18.8203 13.5328 19.0875 13.7203 19.275C13.9078 19.4625 14.175 19.5375 14.4328 19.4719L17.25 18.7687C17.5125 18.7031 17.7563 18.5672 17.9484 18.375L24.0047 12.3141L20.6766 8.98594L14.6203 15.0469Z"
          fill="#7C3AED"
        />
      </g>
      <defs>
        <clipPath id="clip0_670_113360">
          <path d="M0 0H27V24H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  MessageSquareIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 30 24" fill="none">
      <g clipPath="url(#clip0_670_113386)">
        <path
          d="M15 0C15.8297 0 16.5 0.670312 16.5 1.5V4.5H22.125C23.9906 4.5 25.5 6.00938 25.5 7.875V20.625C25.5 22.4906 23.9906 24 22.125 24H7.875C6.00938 24 4.5 22.4906 4.5 20.625V7.875C4.5 6.00938 6.00938 4.5 7.875 4.5H13.5V1.5C13.5 0.670312 14.1703 0 15 0ZM9.75 18C9.3375 18 9 18.3375 9 18.75C9 19.1625 9.3375 19.5 9.75 19.5H11.25C11.6625 19.5 12 19.1625 12 18.75C12 18.3375 11.6625 18 11.25 18H9.75ZM14.25 18C13.8375 18 13.5 18.3375 13.5 18.75C13.5 19.1625 13.8375 19.5 14.25 19.5H15.75C16.1625 19.5 16.5 19.1625 16.5 18.75C16.5 18.3375 16.1625 18 15.75 18H14.25ZM18.75 18C18.3375 18 18 18.3375 18 18.75C18 19.1625 18.3375 19.5 18.75 19.5H20.25C20.6625 19.5 21 19.1625 21 18.75C21 18.3375 20.6625 18 20.25 18H18.75ZM12.375 12C12.375 11.5027 12.1775 11.0258 11.8258 10.6742C11.4742 10.3225 10.9973 10.125 10.5 10.125C10.0027 10.125 9.52581 10.3225 9.17418 10.6742C8.82254 11.0258 8.625 11.5027 8.625 12C8.625 12.4973 8.82254 12.9742 9.17418 13.3258C9.52581 13.6775 10.0027 13.875 10.5 13.875C10.9973 13.875 11.4742 13.6775 11.8258 13.3258C12.1775 12.9742 12.375 12.4973 12.375 12ZM19.5 13.875C19.9973 13.875 20.4742 13.6775 20.8258 13.3258C21.1775 12.9742 21.375 12.4973 21.375 12C21.375 11.5027 21.1775 11.0258 20.8258 10.6742C20.4742 10.3225 19.9973 10.125 19.5 10.125C19.0027 10.125 18.5258 10.3225 18.1742 10.6742C17.8225 11.0258 17.625 11.5027 17.625 12C17.625 12.4973 17.8225 12.9742 18.1742 13.3258C18.5258 13.6775 19.0027 13.875 19.5 13.875ZM2.25 10.5H3V19.5H2.25C1.00781 19.5 0 18.4922 0 17.25V12.75C0 11.5078 1.00781 10.5 2.25 10.5ZM27.75 10.5C28.9922 10.5 30 11.5078 30 12.75V17.25C30 18.4922 28.9922 19.5 27.75 19.5H27V10.5H27.75Z"
          fill="#7C3AED"
        />
      </g>
      <defs>
        <clipPath id="clip0_670_113386">
          <path d="M0 0H30V24H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  fileSaveIcon: (
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.33333 1.5V4.33333C4.33333 4.80004 4.33333 5.0334 4.42416 5.21166C4.50406 5.36846 4.63154 5.49594 4.78834 5.57584C4.9666 5.66667 5.19996 5.66667 5.66667 5.66667H11.3333C11.8 5.66667 12.0334 5.66667 12.2117 5.57584C12.3685 5.49594 12.4959 5.36846 12.5758 5.21166C12.6667 5.0334 12.6667 4.80004 12.6667 4.33333V2.33333M12.6667 16.5V11.1667C12.6667 10.7 12.6667 10.4666 12.5758 10.2883C12.4959 10.1315 12.3685 10.0041 12.2117 9.92416C12.0334 9.83333 11.8 9.83333 11.3333 9.83333H5.66667C5.19996 9.83333 4.9666 9.83333 4.78834 9.92416C4.63154 10.0041 4.50406 10.1315 4.42416 10.2883C4.33333 10.4666 4.33333 10.7 4.33333 11.1667V16.5M16 6.77124V12.5C16 13.9001 16 14.6002 15.7275 15.135C15.4878 15.6054 15.1054 15.9878 14.635 16.2275C14.1002 16.5 13.4001 16.5 12 16.5H5C3.59987 16.5 2.8998 16.5 2.36502 16.2275C1.89462 15.9878 1.51217 15.6054 1.27248 15.135C1 14.6002 1 13.9001 1 12.5V5.5C1 4.09987 1 3.3998 1.27248 2.86502C1.51217 2.39462 1.89462 2.01217 2.36502 1.77248C2.8998 1.5 3.59987 1.5 5 1.5H10.7288C11.1364 1.5 11.3402 1.5 11.5321 1.54605C11.7021 1.58688 11.8647 1.65422 12.0138 1.7456C12.182 1.84867 12.3261 1.9928 12.6144 2.28105L15.219 4.88562C15.5072 5.17387 15.6513 5.318 15.7544 5.48619C15.8458 5.63531 15.9131 5.79789 15.9539 5.96795C16 6.15976 16 6.36358 16 6.77124Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  blueVerifiedSvg: (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1102_44869)">
        <path
          d="M14.6716 3.36203C14.8521 3.79845 15.1985 4.14535 15.6346 4.32646L17.164 4.95994C17.6004 5.14073 17.9472 5.48749 18.128 5.92395C18.3088 6.36041 18.3088 6.8508 18.128 7.28726L17.495 8.81553C17.3141 9.25218 17.3138 9.74307 17.4955 10.1795L18.1275 11.7073C18.2171 11.9235 18.2632 12.1552 18.2633 12.3892C18.2633 12.6232 18.2172 12.855 18.1277 13.0712C18.0381 13.2874 17.9069 13.4838 17.7414 13.6492C17.5759 13.8147 17.3794 13.9459 17.1632 14.0354L15.6349 14.6684C15.1985 14.8489 14.8516 15.1952 14.6705 15.6314L14.037 17.1608C13.8562 17.5972 13.5094 17.944 13.073 18.1248C12.6365 18.3056 12.1461 18.3056 11.7097 18.1248L10.1814 17.4917C9.74492 17.3114 9.2547 17.3118 8.8185 17.4928L7.28913 18.1253C6.85292 18.3057 6.36295 18.3056 5.92685 18.1249C5.49075 17.9443 5.14418 17.5979 4.96327 17.1619L4.32959 15.6321C4.14914 15.1957 3.80276 14.8488 3.36661 14.6677L1.83724 14.0342C1.40098 13.8535 1.05432 13.507 0.873466 13.0707C0.692613 12.6345 0.692368 12.1444 0.872784 11.708L1.50581 10.1797C1.68616 9.74325 1.68579 9.25302 1.50479 8.81683L0.872669 7.28636C0.783046 7.07019 0.736898 6.83848 0.736861 6.60447C0.736823 6.37045 0.782897 6.13873 0.87245 5.92253C0.962003 5.70633 1.09328 5.50989 1.25878 5.34445C1.42428 5.179 1.62075 5.04779 1.83698 4.9583L3.36525 4.32527C3.8013 4.14498 4.14799 3.79904 4.32923 3.36339L4.96271 1.83402C5.1435 1.39757 5.49026 1.0508 5.92672 0.870016C6.36318 0.68923 6.85357 0.68923 7.29003 0.870016L8.8183 1.50305C9.25477 1.68339 9.74499 1.68302 10.1812 1.50202L11.7112 0.870997C12.1476 0.690313 12.6379 0.69035 13.0743 0.8711C13.5106 1.05185 13.8573 1.39851 14.0382 1.83486L14.6718 3.36468L14.6716 3.36203Z"
          fill="#2E90FA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.2207 7.01029C13.3477 6.81093 13.3902 6.56931 13.339 6.3386C13.2878 6.10788 13.147 5.90696 12.9476 5.78004C12.7483 5.65312 12.5066 5.61059 12.2759 5.66181C12.0452 5.71303 11.8443 5.8538 11.7174 6.05316L8.22969 11.5335L6.63369 9.53848C6.48613 9.35392 6.27131 9.23554 6.03647 9.20937C5.80164 9.1832 5.56602 9.25139 5.38147 9.39895C5.19691 9.5465 5.07853 9.76132 5.05236 9.99616C5.02619 10.231 5.09438 10.4666 5.24194 10.6512L7.61694 13.6199C7.70545 13.7307 7.81913 13.8187 7.94853 13.8767C8.07793 13.9347 8.2193 13.961 8.36089 13.9533C8.50248 13.9456 8.64019 13.9043 8.76257 13.8326C8.88495 13.761 8.98846 13.6612 9.0645 13.5415L13.2207 7.01029Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1102_44869">
          <rect width="19" height="19" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  alertSvg: (
    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.9987 0.375C9.49792 0.375 9.95847 0.638672 10.2116 1.07109L17.8053 14.0086C18.062 14.4445 18.062 14.9824 17.8124 15.4184C17.5628 15.8543 17.0952 16.125 16.5925 16.125H1.40495C0.902218 16.125 0.43464 15.8543 0.185031 15.4184C-0.0645789 14.9824 -0.0610632 14.441 0.192062 14.0086L7.78581 1.07109C8.03894 0.638672 8.49948 0.375 8.9987 0.375ZM8.9987 4.875C8.53112 4.875 8.15495 5.25117 8.15495 5.71875V9.65625C8.15495 10.1238 8.53112 10.5 8.9987 10.5C9.46628 10.5 9.84245 10.1238 9.84245 9.65625V5.71875C9.84245 5.25117 9.46628 4.875 8.9987 4.875ZM10.1237 12.75C10.1237 12.4516 10.0052 12.1655 9.7942 11.9545C9.58322 11.7435 9.29707 11.625 8.9987 11.625C8.70033 11.625 8.41419 11.7435 8.20321 11.9545C7.99223 12.1655 7.8737 12.4516 7.8737 12.75C7.8737 13.0484 7.99223 13.3345 8.20321 13.5455C8.41419 13.7565 8.70033 13.875 8.9987 13.875C9.29707 13.875 9.58322 13.7565 9.7942 13.5455C10.0052 13.3345 10.1237 13.0484 10.1237 12.75Z"
        fill="#F97316"
      />
    </svg>
  ),
  dripCampaignSvg: (
    <svg width="23" height="15" viewBox="0 0 23 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5249 0.23164C10.9585 -0.0769537 11.5367 -0.0769537 11.9702 0.23164C12.8492 0.837109 13.9234 1.25117 14.9976 
      1.25117C16.0484 1.25117 17.1617 0.829296 18.021 0.23164C18.4859 -0.100391 19.1187 -0.0730475 19.5523 0.298046C20.1148 0.76289 20.8218 
      1.11836 21.5288 1.28242C22.2007 1.43867 22.6187 2.11055 22.4624 2.78242C22.3062 3.4543 21.6343 3.87227 20.9624 3.71602C20.0054 3.49336 
      19.2085 3.07148 18.689 2.73945C17.5562 3.34883 16.2867 3.75117 14.9976 3.75117C13.7515 3.75117 12.6304 3.36445 11.857 3.01289C11.6304 
      2.90742 11.4234 2.80586 11.2476 2.71211C11.0718 2.80586 10.8687 2.91133 10.6382 3.01289C9.86478 3.36445 8.74368 3.75117 7.49759 
      3.75117C6.20853 3.75117 4.93899 3.34883 3.80618 2.74336C3.28274 3.07148 2.48978 3.49726 1.53274 3.71992C0.860869 3.87617 0.188994 
      3.4582 0.0327442 2.78633C-0.123506 2.11445 0.294463 1.44258 0.966338 1.28633C1.66946 1.11836 2.3804 0.76289 2.93899 0.298046C3.37259 
      -0.0730475 4.0054 -0.0964849 4.47024 0.23164C5.33743 0.829296 6.44681 1.25117 7.49759 1.25117C8.57181 1.25117 9.64603 0.837109 
      10.5249 0.23164ZM11.9702 11.4816C12.8492 12.0871 13.9234 12.5012 14.9976 12.5012C16.0484 12.5012 17.1617 12.0793 18.021 11.4816C18.4859 
      11.1496 19.1187 11.177 19.5523 11.548C20.1148 12.0129 20.8218 12.3684 21.5288 12.5324C22.2007 12.6887 22.6187 13.3605 22.4624 14.0324C22.3062 
      14.7043 21.6343 15.1223 20.9624 14.966C20.0054 14.7434 19.2085 14.3215 18.689 13.9895C17.5562 14.5988 16.2867 15.0012 14.9976 15.0012C13.7515 
      15.0012 12.6304 14.6145 11.857 14.2629C11.6304 14.1574 11.4234 14.0559 11.2476 13.9621C11.0718 14.0559 10.8687 14.1613 10.6382 14.2629C9.86478 
      14.6145 8.74368 15.0012 7.49759 15.0012C6.20853 15.0012 4.93899 14.5988 3.80618 13.9934C3.28274 14.3215 2.48978 14.7473 1.53274 14.9699C0.860869 
      15.1262 0.188994 14.7082 0.0327442 14.0363C-0.123506 13.3645 0.294463 12.6926 0.966338 12.5363C1.67337 12.3723 2.3804 12.0168 2.9429 11.552C3.37649 
      11.1848 4.00931 11.1574 4.47415 11.4855C5.33743 12.0793 6.44681 12.5012 7.49759 12.5012C8.57181 12.5012 9.64603 12.0871 10.5249 11.4816C10.9585 
      11.173 11.5367 11.173 11.9702 11.4816ZM11.9702 5.85664C12.8492 6.46211 13.9234 6.87617 14.9976 6.87617C16.0484 6.87617 17.1617 6.4543 18.021 
      5.85664C18.4859 5.52461 19.1187 5.55195 19.5523 5.92305C20.1148 6.38789 20.8218 6.74336 21.5288 6.90742C22.2007 7.06367 22.6187 7.73555 22.4624 
      8.40742C22.3062 9.0793 21.6343 9.49726 20.9624 9.34101C20.0054 9.11836 19.2085 8.69648 18.689 8.36445C17.5562 8.97383 16.2867 9.37617 14.9976 
      9.37617C13.7515 9.37617 12.6304 8.98945 11.857 8.63789C11.6304 8.53242 11.4234 8.43086 11.2476 8.33711C11.0718 8.43086 10.8687 8.53633 10.6382 
      8.63789C9.86478 8.98945 8.74368 9.37617 7.49759 9.37617C6.20853 9.37617 4.93899 8.97383 3.80618 8.36836C3.28274 8.69648 2.48978 9.12227 1.53274 
      9.34492C0.860869 9.50117 0.188994 9.0832 0.0327442 8.41133C-0.123506 7.73945 0.294463 7.06758 0.966338 6.91133C1.67337 6.74726 2.3804 6.3918 
      2.9429 5.92695C3.37649 5.55586 4.00931 5.53242 4.47415 5.86055C5.33743 6.4543 6.44681 6.87617 7.49759 6.87617C8.57181 6.87617 9.64603 6.46211 
      10.5249 5.85664C10.9585 5.54805 11.5367 5.54805 11.9702 5.85664Z"
        fill="currentColor"
      />
    </svg>
  ),
  editPencilIcon: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.7375 0.677344C14.0531 -0.00703126 12.9469 -0.00703126 12.2625 0.677344L11.3219 1.61484L14.3813
 4.67422L15.3219 3.73359C16.0063 3.04922 16.0063 1.94297 15.3219 1.25859L14.7375 0.677344ZM5.3875 7.55234C5.19687
  7.74297 5.05 7.97734 4.96562 8.23672L4.04063 11.0117C3.95 11.2805 4.02188 11.5773 4.22188 11.7805C4.42188 11.9836
   4.71875 12.0523 4.99062 11.9617L7.76562 11.0367C8.02188 10.9523 8.25625 10.8055 8.45 10.6148L13.6781 5.38359L10.6156 
  2.32109L5.3875 7.55234ZM3 1.99922C1.34375 1.99922 0 3.34297 0 4.99922V12.9992C0 14.6555 1.34375 15.9992 3 15.9992H11C12.6562 
  15.9992 14 14.6555 14 12.9992V9.99922C14 9.44609 13.5531 8.99922 13 8.99922C12.4469 8.99922 12 9.44609 12 9.99922V12.9992C12 
  13.5523 11.5531 13.9992 11 13.9992H3C2.44688 13.9992 2 13.5523 2 12.9992V4.99922C2 4.44609 2.44688 3.99922 3 3.99922H6C6.55312 
  3.99922 7 3.55234 7 2.99922C7 2.44609 6.55312 1.99922 6 1.99922H3Z"
        fill="currentColor"
      />
    </svg>
  ),
  extensionIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" viewBox="0 -960 960 960" className="block w-full h-full">
      <g>
        <path d="M216-135.869q-33.287 0-56.709-23.422-23.422-23.422-23.422-56.709v-172.304q37.609-2 63.218-28.424 25.608-26.424 25.608-63.272t-25.608-63.272q-25.609-26.424-63.218-28.424V-744q0-33.287 23.422-56.709 23.422-23.422 56.709-23.422h161.065q2.631-40.956 31.96-69.315 29.329-28.359 70.75-28.359t70.975 28.199q29.554 28.199 32.185 69.475H744q33.287 0 56.709 23.422 23.422 23.422 23.422 56.709v161.065q40.956 2.631 69.315 31.96 28.359 29.329 28.359 70.75t-28.199 70.975q-28.199 29.554-69.475 32.185V-216q0 33.287-23.422 56.709-23.422 23.422-56.709 23.422H216Zm2.87-83.001h522.26v-522.26H218.87v108.652q42.13 22.63 65.597 63.772 23.468 41.141 23.468 88.706 0 49.01-23.468 90.168Q261-348.674 218.87-327.283v108.413ZM480-480Z" fill="currentColor" />
      </g>
    </svg>
  ),
  cloudUploadIcon: (
    <svg
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M3.9375 12.25C1.76367 12.25 0 10.4863 0 8.3125C0 6.59531 1.09922 5.13516 2.63047 4.59648C2.62773 4.52266 2.625 4.44883 2.625 4.375C2.625 1.95781 4.58281 0 7 0C8.62148 0 10.0352 0.880469 10.7926 2.19297C11.2082 1.91406 11.7113 1.75 12.25 1.75C13.6992 1.75 14.875 2.92578 14.875 4.375C14.875 4.70859 14.8121 5.02578 14.7 5.32109C16.2969 5.64375 17.5 7.05742 17.5 8.75C17.5 10.6832 15.9332 12.25 14 12.25H3.9375ZM6.09766 6.31641C5.84062 6.57344 5.84062 6.98906 6.09766 7.24336C6.35469 7.49766 6.77031 7.50039 7.02461 7.24336L8.09102 6.17695V9.84375C8.09102 10.2074 8.38359 10.5 8.74727 10.5C9.11094 10.5 9.40352 10.2074 9.40352 9.84375V6.17695L10.4699 7.24336C10.727 7.50039 11.1426 7.50039 11.3969 7.24336C11.6512 6.98633 11.6539 6.5707 11.3969 6.31641L9.20937 4.12891C8.95234 3.87188 8.53672 3.87188 8.28242 4.12891L6.09492 6.31641H6.09766Z"
        fill="currentColor"
      />
    </svg>

  ),
  imgIcon: (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.25 1.3125C12.4906 1.3125 12.6875 1.50937 12.6875 1.75V10.4945L12.5508 10.3168L8.83203 5.5043C8.70898 5.34297 8.51484 5.25 8.3125 5.25C8.11016 5.25 7.91875 5.34297 7.79297 5.5043L5.52344 8.44102L4.68945 7.27344C4.56641 7.10117 4.36953 7 4.15625 7C3.94297 7 3.74609 7.10117 3.62305 7.27617L1.43555 10.3387L1.3125 10.5082V10.5V1.75C1.3125 1.50937 1.50937 1.3125 1.75 1.3125H12.25ZM1.75 0C0.784766 0 0 0.784766 0 1.75V10.5C0 11.4652 0.784766 12.25 1.75 12.25H12.25C13.2152 12.25 14 11.4652 14 10.5V1.75C14 0.784766 13.2152 0 12.25 0H1.75ZM3.9375 5.25C4.10986 5.25 4.28053 5.21605 4.43977 5.15009C4.59901 5.08413 4.7437 4.98745 4.86558 4.86558C4.98745 4.7437 5.08413 4.59901 5.15009 4.43977C5.21605 4.28053 5.25 4.10986 5.25 3.9375C5.25 3.76514 5.21605 3.59447 5.15009 3.43523C5.08413 3.27599 4.98745 3.1313 4.86558 3.00942C4.7437 2.88755 4.59901 2.79087 4.43977 2.72491C4.28053 2.65895 4.10986 2.625 3.9375 2.625C3.76514 2.625 3.59447 2.65895 3.43523 2.72491C3.27599 2.79087 3.1313 2.88755 3.00942 3.00942C2.88755 3.1313 2.79087 3.27599 2.72491 3.43523C2.65895 3.59447 2.625 3.76514 2.625 3.9375C2.625 4.10986 2.65895 4.28053 2.72491 4.43977C2.79087 4.59901 2.88755 4.7437 3.00942 4.86558C3.1313 4.98745 3.27599 5.08413 3.43523 5.15009C3.59447 5.21605 3.76514 5.25 3.9375 5.25Z"
        fill="currentColor" />
    </svg>

  ),
  typographyIcon: (
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1779_24591)">
        <path d="M6.94531 1.44375C6.8168 1.10195 6.48867 0.875 6.125 0.875C5.76133 0.875 5.4332 1.10195 5.30469 1.44375L1.58047 11.375H0.875C0.391016 11.375 0 11.766 0 12.25C0 12.734 0.391016 13.125 0.875 13.125H3.5C3.98398 13.125 4.375 12.734 4.375 12.25C4.375 11.766 3.98398 11.375 3.5 11.375H3.45078L3.94297 10.0625H8.30703L8.79922 11.375H8.75C8.26602 11.375 7.875 11.766 7.875 12.25C7.875 12.734 8.26602 13.125 8.75 13.125H11.375C11.859 13.125 12.25 12.734 12.25 12.25C12.25 11.766 11.859 11.375 11.375 11.375H10.6695L6.94531 1.44375ZM7.65078 8.3125H4.59922L6.125 4.24102L7.65078 8.3125Z" fill="#7C5CFC" />
      </g>
      <defs>
        <clipPath id="clip0_1779_24591">
          <path d="M0 0H12.25V14H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>

  ),
  colorPalateIcon: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 7C14 7.02461 14 7.04922 14 7.07383C13.9891 8.07188 13.0813 8.75 12.0832 8.75H9.40625C8.68164 8.75 8.09375 9.33789 8.09375 10.0625C8.09375 10.1555 8.10469 10.2457 8.12109 10.3332C8.17852 10.6121 8.29883 10.8801 8.41641 11.1508C8.5832 11.5281 8.74727 11.9027 8.74727 12.2992C8.74727 13.1687 8.15664 13.959 7.28711 13.9945C7.19141 13.9973 7.0957 14 6.99727 14C3.13359 14 0 10.8664 0 7C0 3.13359 3.13359 0 7 0C10.8664 0 14 3.13359 14 7ZM3.5 7.875C3.5 7.64294 3.40781 7.42038 3.24372 7.25628C3.07962 7.09219 2.85706 7 2.625 7C2.39294 7 2.17038 7.09219 2.00628 7.25628C1.84219 7.42038 1.75 7.64294 1.75 7.875C1.75 8.10706 1.84219 8.32962 2.00628 8.49372C2.17038 8.65781 2.39294 8.75 2.625 8.75C2.85706 8.75 3.07962 8.65781 3.24372 8.49372C3.40781 8.32962 3.5 8.10706 3.5 7.875ZM3.5 5.25C3.73206 5.25 3.95462 5.15781 4.11872 4.99372C4.28281 4.82962 4.375 4.60706 4.375 4.375C4.375 4.14294 4.28281 3.92038 4.11872 3.75628C3.95462 3.59219 3.73206 3.5 3.5 3.5C3.26794 3.5 3.04538 3.59219 2.88128 3.75628C2.71719 3.92038 2.625 4.14294 2.625 4.375C2.625 4.60706 2.71719 4.82962 2.88128 4.99372C3.04538 5.15781 3.26794 5.25 3.5 5.25ZM7.875 2.625C7.875 2.39294 7.78281 2.17038 7.61872 2.00628C7.45462 1.84219 7.23206 1.75 7 1.75C6.76794 1.75 6.54538 1.84219 6.38128 2.00628C6.21719 2.17038 6.125 2.39294 6.125 2.625C6.125 2.85706 6.21719 3.07962 6.38128 3.24372C6.54538 3.40781 6.76794 3.5 7 3.5C7.23206 3.5 7.45462 3.40781 7.61872 3.24372C7.78281 3.07962 7.875 2.85706 7.875 2.625ZM10.5 5.25C10.7321 5.25 10.9546 5.15781 11.1187 4.99372C11.2828 4.82962 11.375 4.60706 11.375 4.375C11.375 4.14294 11.2828 3.92038 11.1187 3.75628C10.9546 3.59219 10.7321 3.5 10.5 3.5C10.2679 3.5 10.0454 3.59219 9.88128 3.75628C9.71719 3.92038 9.625 4.14294 9.625 4.375C9.625 4.60706 9.71719 4.82962 9.88128 4.99372C10.0454 5.15781 10.2679 5.25 10.5 5.25Z"
        fill="currentColor" />
    </svg>
  ),
  layoutIcon: (
    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 1.75C0 0.784766 0.784766 0 1.75 0H12.25C13.2152 0 14 0.784766 14 1.75V10.5C14 11.4652 13.2152 12.25 12.25 12.25H1.75C0.784766 12.25 0 11.4652 0 10.5V1.75ZM1.75 3.5V10.5H6.125V3.5H1.75ZM12.25 3.5H7.875V10.5H12.25V3.5Z"
        fill="currentColor" />
    </svg>

  ),
  portraitIcon: (
    <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 1.75C0 0.784766 0.784766 0 1.75 0H6.125V3.5C6.125 3.98398 6.51602 4.375 7 4.375H10.5V12.25C10.5 13.2152 9.71523 14 8.75 14H1.75C0.784766 14 0 13.2152 0 12.25V1.75ZM10.5 3.5H7V0L10.5 3.5Z"
        fill="currentColor" />
    </svg>

  ),
  landscapeIcon: (
    <svg width="8" height="11" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 1.3125C0 0.588574 0.588574 0 1.3125 0H4.59375V2.625C4.59375 2.98799 4.88701 3.28125 5.25 3.28125H7.875V9.1875C7.875 9.91143 7.28643 10.5 6.5625 10.5H1.3125C0.588574 10.5 0 9.91143 0 9.1875V1.3125ZM7.875 2.625H5.25V0L7.875 2.625Z"
        fill="currentColor" />
    </svg>

  ),
  coverPageSkeleton: (
    <svg width="68" height="38" viewBox="0 0 68 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_1835_72131)">
        <path d="M2 5C2 2.79086 3.79086 1 6 1H62C64.2091 1 66 2.79086 66 5V31C66 33.2091 64.2091 35 62 35H6C3.79086 35 2 33.2091 2 31V5Z" fill="white" />
        <path d="M6 1.5H62C63.933 1.5 65.5 3.067 65.5 5V31C65.5 32.933 63.933 34.5 62 34.5H6C4.067 34.5 2.5 32.933 2.5 31V5C2.5 3.067 4.067 1.5 6 1.5Z" stroke="#E5E7EB" />
        <path d="M65 24H3V12H65V24Z" stroke="#E5E7EB" />
        <path d="M42 14H26V12H42V14Z" fill="#D1D5DB" />
        <path d="M42 14H26V12H42V14Z" stroke="#E5E7EB" />
        <path d="M46 20H22V16H46V20Z" fill="#1F2937" />
        <path d="M46 20H22V16H46V20Z" stroke="#E5E7EB" />
        <path d="M42 24H26V22H42V24Z" fill="#D1D5DB" />
        <path d="M42 24H26V22H42V24Z" stroke="#E5E7EB" />
      </g>
      <defs>
        <filter id="filter0_d_1835_72131" x="0" y="0" width="68" height="38" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1835_72131" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1835_72131" result="shape" />
        </filter>
      </defs>
    </svg>

  ),
  candidateCriteriaSkeleton: (
    <svg width="68" height="42" viewBox="0 0 68 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_1835_72147)">
        <path d="M2 5C2 2.79086 3.79086 1 6 1H62C64.2091 1 66 2.79086 66 5V35C66 37.2091 64.2091 39 62 39H6C3.79086 39 2 37.2091 2 35V5Z" fill="white" />
        <path d="M6 1.5H62C63.933 1.5 65.5 3.067 65.5 5V35C65.5 36.933 63.933 38.5 62 38.5H6C4.067 38.5 2.5 36.933 2.5 35V5L2.50488 4.82031C2.59842 2.97083 4.12727 1.5 6 1.5Z" stroke="#E5E7EB" />
        <path d="M65 32H3V8H65V32Z" stroke="#E5E7EB" />
        <path d="M24.3281 32H7V8H24.3281V32Z" fill="#F3F4F6" />
        <path d="M24.3281 32H7V8H24.3281V32Z" stroke="#E5E7EB" />
        <path d="M61 32H26.3281V8H61V32Z" stroke="#E5E7EB" />
        <path d="M61 12H26.3281V8H61V12Z" fill="#E5E7EB" />
        <path d="M61 12H26.3281V8H61V12Z" stroke="#E5E7EB" />
        <path d="M52.3281 18H26.3281V14H52.3281V18Z" fill="#E5E7EB" />
        <path d="M52.3281 18H26.3281V14H52.3281V18Z" stroke="#E5E7EB" />
        <path d="M61 24H26.3281V20H61V24Z" fill="#E5E7EB" />
        <path d="M61 24H26.3281V20H61V24Z" stroke="#E5E7EB" />
      </g>
      <defs>
        <filter id="filter0_d_1835_72147" x="0" y="0" width="68" height="42" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1835_72147" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1835_72147" result="shape" />
        </filter>
      </defs>
    </svg>

  ),
  marketAnalysisSkeleton: (
    <svg width="68" height="42" viewBox="0 0 68 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_1835_72165)">
        <path d="M2 5C2 2.79086 3.79086 1 6 1H62C64.2091 1 66 2.79086 66 5V35C66 37.2091 64.2091 39 62 39H6C3.79086 39 2 37.2091 2 35V5Z" fill="white" />
        <path d="M6 1.5H62C63.933 1.5 65.5 3.067 65.5 5V35C65.5 36.933 63.933 38.5 62 38.5H6C4.067 38.5 2.5 36.933 2.5 35V5L2.50488 4.82031C2.59842 2.97083 4.12727 1.5 6 1.5Z" stroke="#E5E7EB" />
        <path d="M65 29H3V11H65V29Z" stroke="#E5E7EB" />
        <path d="M54 15H14V11H54V15Z" fill="#E5E7EB" />
        <path d="M54 15H14V11H54V15Z" stroke="#E5E7EB" />
        <path d="M54 29H14V17H54V29Z" stroke="#E5E7EB" />
        <path d="M20 17C23.3137 17 26 19.6863 26 23C26 26.3137 23.3137 29 20 29C16.6863 29 14 26.3137 14 23C14 19.6863 16.6863 17 20 17Z" fill="#E5E7EB" />
        <path d="M20 17C23.3137 17 26 19.6863 26 23C26 26.3137 23.3137 29 20 29C16.6863 29 14 26.3137 14 23C14 19.6863 16.6863 17 20 17Z" stroke="#E5E7EB" />
        <path d="M34 17C37.3137 17 40 19.6863 40 23C40 26.3137 37.3137 29 34 29C30.6863 29 28 26.3137 28 23C28 19.6863 30.6863 17 34 17Z" fill="#E5E7EB" />
        <path d="M34 17C37.3137 17 40 19.6863 40 23C40 26.3137 37.3137 29 34 29C30.6863 29 28 26.3137 28 23C28 19.6863 30.6863 17 34 17Z" stroke="#E5E7EB" />
        <path d="M48 17C51.3137 17 54 19.6863 54 23C54 26.3137 51.3137 29 48 29C44.6863 29 42 26.3137 42 23C42 19.6863 44.6863 17 48 17Z" fill="#E5E7EB" />
        <path d="M48 17C51.3137 17 54 19.6863 54 23C54 26.3137 51.3137 29 48 29C44.6863 29 42 26.3137 42 23C42 19.6863 44.6863 17 48 17Z" stroke="#E5E7EB" />
      </g>
      <defs>
        <filter id="filter0_d_1835_72165" x="0" y="0" width="68" height="42" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1835_72165" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1835_72165" result="shape" />
        </filter>
      </defs>
    </svg>

  ),
  dragIcon: (
    <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.25 10H2.75C3.44062 10 4 10.5594 4 11.25V12.75C4 13.4406 3.44062 14 2.75 14H1.25C0.559375 14 0 13.4406 0 12.75V11.25C0 10.5594 0.559375 10 1.25 10ZM7.25 10H8.75C9.44063 10 10 10.5594 10 11.25V12.75C10 13.4406 9.44063 14 8.75 14H7.25C6.55937 14 6 13.4406 6 12.75V11.25C6 10.5594 6.55937 10 7.25 10ZM1.25 9C0.559375 9 0 8.44063 0 7.75V6.25C0 5.55937 0.559375 5 1.25 5H2.75C3.44062 5 4 5.55937 4 6.25V7.75C4 8.44063 3.44062 9 2.75 9H1.25ZM7.25 5H8.75C9.44063 5 10 5.55937 10 6.25V7.75C10 8.44063 9.44063 9 8.75 9H7.25C6.55937 9 6 8.44063 6 7.75V6.25C6 5.55937 6.55937 5 7.25 5ZM1.25 4C0.559375 4 0 3.44062 0 2.75V1.25C0 0.559375 0.559375 0 1.25 0H2.75C3.44062 0 4 0.559375 4 1.25V2.75C4 3.44062 3.44062 4 2.75 4H1.25ZM7.25 0H8.75C9.44063 0 10 0.559375 10 1.25V2.75C10 3.44062 9.44063 4 8.75 4H7.25C6.55937 4 6 3.44062 6 2.75V1.25C6 0.559375 6.55937 0 7.25 0Z"
        fill="currentColor" />
    </svg>

  ),
  profileIcon: (
    <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.4375 3.5V10.5C14.4375 10.7406 14.2406 10.9375 14 10.9375H8.75C8.75 9.72891 7.77109 8.75 6.5625 8.75H4.8125C3.60391 8.75 2.625 9.72891 2.625 10.9375H1.75C1.50937 10.9375 1.3125 10.7406 1.3125 10.5V3.5H14.4375ZM1.75 0C0.784766 0 0 0.784766 0 1.75V10.5C0 11.4652 0.784766 12.25 1.75 12.25H14C14.9652 12.25 15.75 11.4652 15.75 10.5V1.75C15.75 0.784766 14.9652 0 14 0H1.75ZM7.4375 6.125C7.4375 5.66087 7.25313 5.21575 6.92494 4.88756C6.59675 4.55937 6.15163 4.375 5.6875 4.375C5.22337 4.375 4.77825 4.55937 4.45006 4.88756C4.12187 5.21575 3.9375 5.66087 3.9375 6.125C3.9375 6.58913 4.12187 7.03425 4.45006 7.36244C4.77825 7.69063 5.22337 7.875 5.6875 7.875C6.15163 7.875 6.59675 7.69063 6.92494 7.36244C7.25313 7.03425 7.4375 6.58913 7.4375 6.125ZM10.2812 4.8125C9.91758 4.8125 9.625 5.10508 9.625 5.46875C9.625 5.83242 9.91758 6.125 10.2812 6.125H12.4688C12.8324 6.125 13.125 5.83242 13.125 5.46875C13.125 5.10508 12.8324 4.8125 12.4688 4.8125H10.2812ZM10.2812 7.4375C9.91758 7.4375 9.625 7.73008 9.625 8.09375C9.625 8.45742 9.91758 8.75 10.2812 8.75H12.4688C12.8324 8.75 13.125 8.45742 13.125 8.09375C13.125 7.73008 12.8324 7.4375 12.4688 7.4375H10.2812Z"
        fill="currentColor" />
    </svg>

  ),
  calenderIcon: (
    <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.75 0.75C4.75 0.334375 4.41563 0 4 0C3.58437 0 3.25 0.334375 3.25 0.75V2H2C0.896875 2 0 2.89687 0 4V4.5V6V14C0 15.1031 0.896875 16 2 16H12C13.1031 16 14 15.1031 14 14V6V4.5V4C14 2.89687 13.1031 2 12 2H10.75V0.75C10.75 0.334375 10.4156 0 10 0C9.58438 0 9.25 0.334375 9.25 0.75V2H4.75V0.75ZM1.5 6H12.5V14C12.5 14.275 12.275 14.5 12 14.5H2C1.725 14.5 1.5 14.275 1.5 14V6Z"
        fill="currentColor"
      />
    </svg>

  ),
  historyIcon: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.05078 2.05078L1.12109 1.12109C0.708203 0.708203 0 1.00078 0 1.5832V4.59375C0 4.95742 0.292578 5.25 0.65625 5.25H3.6668C4.25195 5.25 4.54453 4.5418 4.13164 4.12891L3.28945 3.28672C4.23828 2.33789 5.55078 1.75 7 1.75C9.89844 1.75 12.25 4.10156 12.25 7C12.25 9.89844 9.89844 12.25 7 12.25C5.88438 12.25 4.85078 11.9027 4.00039 11.3094C3.60391 11.0332 3.05977 11.1289 2.78086 11.5254C2.50195 11.9219 2.60039 12.466 2.99688 12.7449C4.13438 13.5352 5.51523 14 7 14C10.8664 14 14 10.8664 14 7C14 3.13359 10.8664 0 7 0C5.0668 0 3.3168 0.784766 2.05078 2.05078ZM7 3.5C6.63633 3.5 6.34375 3.79258 6.34375 4.15625V7C6.34375 7.175 6.41211 7.3418 6.53516 7.46484L8.50391 9.43359C8.76094 9.69063 9.17656 9.69063 9.43086 9.43359C9.68516 9.17656 9.68789 8.76094 9.43086 8.50664L7.65352 6.7293V4.15625C7.65352 3.79258 7.36094 3.5 6.99727 3.5H7Z"
        fill="currentColor" />
    </svg>

  ),
  linkIcon: (
    <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.3665 6.74995C16.9114 5.20502 16.9114 2.70307 15.3665 1.15815C13.9993 -0.209038 11.8446 -0.386773 10.2724 0.737056L10.2286 0.767134C9.83486 1.04877 9.74463 1.59565 10.0263 1.98666C10.3079 2.37768 10.8548 2.47065 11.2458 2.18901L11.2896 2.15893C12.1673 1.53276 13.3677 1.6312 14.1278 2.39409C14.9892 3.25541 14.9892 4.64995 14.1278 5.51127L11.0599 8.58471C10.1985 9.44604 8.804 9.44604 7.94268 8.58471C7.17978 7.82182 7.08135 6.62143 7.70752 5.74643L7.7376 5.70268C8.01924 5.30893 7.92627 4.76206 7.53525 4.48315C7.14424 4.20424 6.59463 4.29448 6.31572 4.68549L6.28564 4.72924C5.15908 6.29877 5.33682 8.45346 6.704 9.82065C8.24893 11.3656 10.7509 11.3656 12.2958 9.82065L15.3665 6.74995ZM1.15869 6.1101C-0.38623 7.65502 -0.38623 10.157 1.15869 11.7019C2.52588 13.0691 4.68057 13.2468 6.25283 12.123L6.29658 12.0929C6.69033 11.8113 6.78057 11.2644 6.49893 10.8734C6.21729 10.4824 5.67041 10.3894 5.27939 10.671L5.23564 10.7011C4.35791 11.3273 3.15752 11.2289 2.39736 10.466C1.53604 9.6019 1.53604 8.20737 2.39736 7.34604L5.46533 4.27534C6.32666 3.41401 7.72119 3.41401 8.58252 4.27534C9.34541 5.03823 9.44385 6.23862 8.81767 7.11635L8.7876 7.1601C8.50596 7.55385 8.59893 8.10073 8.98994 8.37963C9.38096 8.65854 9.93057 8.56831 10.2095 8.17729L10.2395 8.13354C11.3661 6.56127 11.1884 4.40659 9.82119 3.0394C8.27627 1.49448 5.77432 1.49448 4.22939 3.0394L1.15869 6.1101Z"
        fill="currentColor" />
    </svg>

  )

};
